import { useFormik, setNestedObjectValues } from 'formik'
import { Fragment, useEffect, useState, useRef } from 'react';
import { PageTitle } from '../../../../_metronic/layout/core'
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { RootState } from '../../../../setup'
import { UserModel } from '../../../modules/auth/models/UserModel'
import FreightInformation from '../../../components/LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformation';
import { FreightTotals } from '../../../components/LTLandVolumeTLPages/FreightInfo/FreightTotals';
import SelectUOM from '../../../components/LTLandVolumeTLPages/FreightInfo/SelectUOM';
import Accessorials from '../../../components/LTLandVolumeTLPages/AccesorialsComponent/Accessorials';
import PickupAndDelivery from '../../../components/NewBookingPage/PickupAndDelivery';
import Tabs from '../../../components/NewBookingPage/Tabs';
import OriginAndDestination from '../../../components/NewBookingPage/OriginAndDestination';
import QuoteBreakdownModal from '../../../components/LTLandVolumeTLPages/Modals/QuoteBreakdownModal';
import CarrierInformation from './CarrierInformation';
import ConfirmClearRateModal from './ConfirmClearRateModal';
import { initialValues, validationSchema} from '../../../helpers/createNewBookingFormik';
import { marginSize } from '../../../helpers/marginSize';
import { portsModel, quoteValuesModel } from '../../../components/PagesModels';
import axios from 'axios';
import { actionTypes } from '../../../modules/auth/redux/PagesRedux';
import { isTokenExp } from '../../../helpers/isTokenExp';
import RatesModal from '../../../components/NewBookingPage/RatesModal';
import { format } from 'date-fns';
import { CircularProgress, IconButton, MenuItem, TextField, Tooltip, Autocomplete } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { checkErrorAPICall } from '../../../helpers/checkErrorAPICall';
import TrackingModal from '../../../components/TrackingGridPage/TrackingModal';
import DocumentsModal from '../../../components/TrackingGridPage/DocumentsModal/DocumentsModal';
import ShipmentCreatedOrUpdatedModal from '../../../components/NewBookingPage/ShipmentCreatedOrUpdatedModal';
import { useNavigate } from 'react-router-dom';
import ClearRateToEditModal from '../../../components/NewBookingPage/ClearRateToEditModal';
import SaveChangesModal from '../../../components/NewBookingPage/SaveChangesModal';
import HazContactModal from '../../../components/NewBookingPage/HazContactModal';
import PickupDatePastModal from '../../../components/NewBookingPage/PickupDatePastModal';
import { InputStyled, SelectStyled, TextFieldStyled } from '../../../components/Inputs.styled';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { stylesMUIInput } from '../../../components/stylesMUIInput';
import { useStyles } from '../../../components/LTLandVolumeTLPages/FreightInfo/FreightInformation/FreightInformationStyles';
import Container from '../../../components/DrayagePage/Container';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { normalizeParams } from '../../../helpers/NewBooking/normalizeParams';
import { normalizeParamsShipment } from '../../../helpers/NewBooking/normalizeParamsShipment';
import { openMaps } from '../../../helpers/NewBooking/openMaps';
import { formatPhone } from '../../../helpers/formatPhone';
import { ReactMultiEmailStyled } from '../../../components/NewBookingPage/OriginAndDestination.styled';
import { ChipStyled } from '../../../components/LTLandVolumeTLPages/AccesorialsComponent/Accesorials.styled';
import EditIcon from '@mui/icons-material/Edit';
import ChangeBOLNumberModal from '../../../components/NewBookingPage/ChangeBOLNumberModal';
import AttachPRONumberModal from '../../../components/NewBookingPage/AttachPRONumberModal';
import ErrorsInPageModal from './ErrorsInPageModal';
import VendorCollectModal from './vendorCollectModal';
// import { getRates } from '../../../helpers/getRates';
import { getRatesWithLimit } from '../../../helpers/getRatesWithLimit';
import ConfirmTimedOutVendorsModal from '../../../components/LTLandVolumeTLPages/Modals/ConfirmTimedOutVendorsModal';
import NoVendorsSetUpModal from '../../../components/Modals/NoVendorsSetUpModal';
import InsuranceRequiredModal from './InsuranceRequiredModal';
import { CountryOptions } from '../../../data/CountryOptions';
import SmallPackageOptionsModal from '../../../components/NewBookingPage/SmallPackageOptionsModal';
import moment from 'moment';
import DateIsWeekendModal from '../../../components/NewBookingPage/DateIsWeekendModal';
import CarrierRequiredModal from './CarrierRequiredModal';
import NMFCRequiredModal from './NMFCRequiredModal';
import AddRateRemarksModal from './AddRatesRemarksModal';
import { calculateEmail } from '../../../helpers/calculateEmail';
import { getTransitHours } from '../../../helpers/transitTime';
import BillToCollect from '../../../components/NewBookingPage/BillToCollect';
import StreamlineSaveDropdown from './StreamlineSaveDropdown';
import UploadDocument from '../../../components/TrackingGridPage/DocumentsModal/UploadDocument';

interface freightErrors {
  qty: string,
  weight: string,
  nmfc: string,
  L: string,
  W: string,
  H: string
}

const GET_RATES = '/applet/v1/rate'
const GET_RATES_SUB_VENDOR = '/applet/v1/rate/p2p'
const HISTORYTRACKINGS = '/api/v1/track'
const DOCUMENTS = '/applet/v1/document'
const UPLOAD_DOCUMENT = '/applet/v1/document/upload'
const CREATE_SHIPMENT = '/applet/v1/book'
const DISPATCH_SHIPMENT = '/applet/v2/dispatch'
const CALCULATE_DVLDATE = '/api/v1/tools/calculatedeliverydate'
const GET_LANEDISTANCE = '/api/v1/tools/distancematrix'
const SHIPMENT_MODES = '/api/v1/shipmentmodes'
const CHECK_CARRIERLABELS = '/api/v1/dispatch'
const ADD_STOPS = '/api/v1/book'
const CREATE_QUOTE_REDKIK = '/api/v1/tools/redkik/createquote'
const VENDORS_COLLECT = 'api/v1/database/vendor/collect'
const VENDORBYID = 'api/v1/database/vendor'
const GET_CONTACTS = '/applet/v1/database/contacts'
let submitButtonLet = ''
let cancelToken = axios.CancelToken
let source = cancelToken.source()

export const NewBooking = () => {
  const isMountedRef = useRef(true)
  const dispatch = useDispatch()
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
  const ports = useSelector<any>((store) => store.pages.drayagePorts) as portsModel
  const customerInfo = useSelector(({auth}: any) => auth.customerInfo)
  const resetValues = useSelector<RootState>(({pages}) => pages?.resetValues) as boolean
  const initialNewBookingValues = useSelector<RootState>(({pages}) => pages.initialNewBooking) as any
  const navigate = useNavigate()
  const initializedRef = useRef(false);
  const bolDisplayRef = useRef({ prefix: '', number: '' })

  const [selectedAcc, setSelectedAcc] = useState([])
  const [openQuoteBreakdownModal, setOpenQuoteBreakdownModal] = useState(false)
  const [touchedDate, setTouchedDate] = useState({
    pickup: false,
    delivery: false
  })
  const [openConfirmClearRateModal, setOpenConfirmClearRateModal] = useState(false)
  const quoteValues = useSelector<RootState>(({pages}) => pages.quoteValues) as quoteValuesModel
  const newBookingValues = useSelector<RootState>(({pages}) => pages.newBookingValues) as any
  const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
  const [rates, setRates] = useState([])
  const [linearProgress, setLinearProgress] = useState(0)
  const [ratesStopped, setRatesStopped] = useState(false)
  const [openRatesModal, setOpenRatesModal] = useState(false)
  const [loadingDocuments, setLoadingDocuments] = useState(false)
  const [loadingTracking, setLoadingTracking] = useState(false)
  const [loadingCreateShipment, setLoadingCreateShipment] = useState(false)
  const [loadingDispatchShipment, setLoadingDispatchShipment] = useState(false)
  const [loadingUpdateShipment, setLoadingUpdateShipment] = useState(false)
  const [historyTrackings, setHistoryTrackings] = useState([])
  const [openTrackingModal, setOpenTrackingModal] = useState(false)
  const [documents, setDocuments] = useState([])
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false)
  const [openShipmentCreatedModal, setOpenShipmentCreatedModal] = useState(false)
  const [openClearRateToEditModal, setOpenClearRateToEditModal] = useState(false)
  const [openSaveChangesModal, setOpenSaveChangesModal] = useState(false)
  const [openHazContactModal, setOpenHazContactModal] = useState(false)
  const [openPickupDatePastModal, setOpenPickupDatePastModal] = useState(false)
  const [openChangeBOLModal, setOpenChangeBOLModal] = useState(false)
  const [openAttachPROModal, setOpenAttachPROModal] = useState(false)
  const [openErrorsInPageModal, setOpenErrorsInPageModal] = useState(false)
  const [dispatchShip, setDispatchShip] = useState(false)
  const [createOrUpdate, setCreateOrUpdate] = useState('')
  const [mode, setMode] = useState({} as {shipmentCategory: string, name: string, id: number, ratingCode: string})
  const [modeLocal, setModeLocal] = useState('')
  const [modes, setModes] = useState([])
  const [actionClicked, setActionClicked] = useState(false)
  const [vendorName, setVendorName] = useState(null);
  const [selectedUn, setSelectedUn] = useState([])
  const [newValuesWhenRateCleared, setNewValuesWhenRateCleared] = useState({valuesFor: '', values: undefined})
  const [enabledVendors, setEnabledVendors] = useState([])
  const [vendorsProcessed, setVendorsProcessed] = useState('0')
  const [vendorsTimedOut, setVendorsTimedOut] = useState([])
  const [openConfirmTimedOutModal, setOpenConfirmTimedOutModal] = useState(false)
  const [openNoVendorsSetUpModal, setOpenNoVendorsSetUpModal] = useState(false)
  const [openInsuranceRequiredModal, setOpenInsuranceRequiredModal] = useState(false)
  const [openCarrierRequiredModal, setOpenCarrierRequiredModal] = useState(false)
  const [openNMFCRequiredModal, setOpenNMFCRequiredModal] = useState(false)
  const [openSmallPackageOptionsModal, setOpenSmallPackageOptionsModal] = useState(false)
  const [smallPackageOptions, setSmallPackageOptions] = useState({})
  const [closeAcc, setCloseAcc] = useState(false)
  const [openDateIsWeekendModal, setOpenDateIsWeekendModal] = useState(false)
  const [dateIsWeekendData, setDateIsWeekendData] = useState({})
  const [isAccesorialsOpenend, setIsAccesorialsOpenend ] = useState(false)
  const [openAddRateRemarksModal, setOpenAddRateRemarksModal] = useState(false)
  const [vendorsCollect, setVendorsCollect] = useState([])
  const [openCollectVendorSetup ,setOpenCollectVendorSetup] = useState(false)
  const [openCollectInformationModal, setOpenCollectInformationModal] = useState(false)
  const [isStreamline, setIsStreamline] = useState(!!user?.enableDispatchStreamline)
  const [openUploadDocumentsTemporaryModal, setOpenUploadDocumentsTemporaryModal] = useState(false)
  const [pendingDocuments, setPendingDocuments] = useState<Array<{file: File, type: string, typeCode: string, id: string}>>([])
  // const [selectedVendorCollect, setSelectedVendorCollect] = useState()

  const [isCollect, setIsCollect] = useState(false)
  const [submitButton, setSubmitButton] = useState('')

  const classes = useStyles({
    fontSize: fontSize,
  })

  const menuProps = {
    classes: {
      list: classes.selectPaperList
    }
  }

  const addStops = (id) => {
    let regexDate = new RegExp(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)

    let stops = formik.values?.stops?.stops?.map((stop) => {
      return ({
        "stopNumber": stop?.stopNumber,
        "reference": stop?.reference,
        "pickupDelivery": stop?.type,
        "pickupDeliveryDate": stop?.date ? (!regexDate.test(stop?.date) ? format(stop?.date || null, 'yyyy-MM-dd') : stop?.date) : '',
        "pickupDeliveryTimeFrom": stop?.from,
        "pickupDeliveryTimeTo": stop?.to,
        "name": stop?.name,
        "address1": stop?.address,
        "address2": stop?.address1,
        "city": stop?.city,
        "cityAlias": stop?.city,
        "state": stop?.state,
        "zipcode": stop?.zipcode,
        "country": stop?.country,
        "phone": stop?.phone,
        "fax": "",
        "email": "",
        "contact": stop?.contact,
        "contactPhone": stop?.contactPhone,
        "notes": stop?.notes,
        "PODDate": stop?.PODDate ? (!regexDate.test(stop?.PODDate) ? format(stop?.PODDate || null, 'yyyy-MM-dd') : stop?.PODDate) : '',
        "signedBy": stop.signedBy
      })
    })

    axios.post(`${ADD_STOPS}/${id}/stops`, {stops: stops})
  }

  const hasInvalidEmails = () => {
    return !!(formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length
      || formik.values?.shipper?.emails && formik.values?.shipper?.emails?.filter(email => email?.includes('notanemail'))?.length
      || formik.values?.consignee?.emails && formik.values?.consignee?.emails?.filter(email => email?.includes('notanemail'))?.length
  }

  const validateDispatchBusinessRules = () => {
    const values = formik.values

    if (formik?.errors?.pickupDate?.to === 'Must be after from') {
      setOpenErrorsInPageModal(true)
      return false
    }

    const hasCarrier = values?.carrierInformation?.rateId
      || values?.carrierInformation?.vendorId
      || (isCollect && values?.selectedVendorCollect && values?.collectVendorId)

    if (!hasCarrier) {
      if (isCollect && values?.selectedVendorCollect && !values.collectVendorId) {
        setOpenCollectVendorSetup(true)
      } else {
        setOpenCarrierRequiredModal(true)
      }

      if (isCollect && !values?.selectedVendorCollect) {
        formik.setFieldError('selectedVendorCollect', 'required')
      }
      return false
    }

    const selectedVendor = user.enabledVendors?.find(v => v.id === values?.carrierInformation?.vendorId)
    const requiresNMFC = selectedVendor?.requirePickupNMFC
    const allFreightHaveNMFC = values?.freightInfo?.every(freight => freight?.nmfc && freight?.nmfc?.trim() !== '')

    if (requiresNMFC && !allFreightHaveNMFC) {
      setOpenNMFCRequiredModal(true)
      return false
    }

    return true
  }

  const validateDispatchRequired = async (options: { toggleActionClicked?: boolean } = {}) => {
    const { toggleActionClicked = true } = options
    submitButtonLet = 'book'
    setSubmitButton('book')
    if (toggleActionClicked) {
      setActionClicked(!actionClicked)
    }
    setDispatchShip(true)

    if (!validateStreamlineSaveBooking()) return false

    const errors = await formik.validateForm()
    if (Object.keys(errors).length) {
      formik.setTouched(setNestedObjectValues(formik.values, true))
      setTouchedDate({ pickup: true, delivery: true })
      setOpenErrorsInPageModal(true)
      window.scrollTo(0, 0)
      return false
    }

    if (hasInvalidEmails()) {
      setOpenErrorsInPageModal(true)
      return false
    }

    if (!validateDispatchBusinessRules()) return false

    return true
  }

  type DispatchOptions = {
    bolId?: string | number
    skipUpdate?: boolean
  }

  const handleStreamlinePostSave = (
    streamlineAction: 'dispatch' | 'close' | null,
    options?: DispatchOptions
  ) => {
    if (streamlineAction === 'close') {
      navigate('/trackings')
      return
    }
    if (streamlineAction === 'dispatch') {
      executeDispatchAfterSave({
        bolId: options?.bolId ?? formik.values.BOLId,
        skipUpdate: options?.skipUpdate ?? false,
      })
      return
    }
    setOpenShipmentCreatedModal(true)
  }

  const triggerReadyToDispatch = async () => {
    if (!(await validateDispatchRequired())) return

    setTimeout(() => {
      formik.handleSubmit()
    }, 1)
  }

  const validateStreamlineSaveBooking = () => {
    if ([...formik?.values?.accessorials?.origin, ...formik?.values?.accessorials?.destination, ...formik?.values?.accessorials?.other].filter(a => a.code === 'INS')?.length
      && (!formik?.values?.moneyAccessorialsInformation?.filter(a => a.code === 'INS' && a.insuranceAmount).length && !formik?.values?.insuranceAmount)) {
      setOpenInsuranceRequiredModal(true)
      return false
    }
    if (isCollect && formik?.values?.selectedVendorCollect && !formik.values.collectVendorId) {
      setOpenCollectVendorSetup(true)
      return false
    }
    return true
  }

  const handleStreamlineSaveBooking = () => {
    setActionClicked(!actionClicked)
    setDispatchShip(false)
    if (!validateStreamlineSaveBooking()) return
    if (formik.values?.BOLId) updateShipment()
    else createShipment()
  }

  const handleStreamlineSaveAndDispatch = async () => {
    if (!(await validateDispatchRequired())) return
    const bolId = formik.values?.BOLId
    if (bolId) {
      if (formik.dirty) {
        updateShipment('dispatch')
      } else {
        executeDispatchAfterSave({ bolId, skipUpdate: true })
      }
    } else {
      createShipment('dispatch')
    }
  }

  const handleStreamlineSaveAndClose = () => {
    setActionClicked(!actionClicked)
    setDispatchShip(false)
    if (!validateStreamlineSaveBooking()) return
    if (formik.values?.BOLId) updateShipment('close')
    else createShipment('close')
  }

  const uploadPendingDocuments = (bolNumber: string): Promise<void> => {
    if (!pendingDocuments.length) return Promise.resolve()
    const uploads = pendingDocuments.map(doc => {
      const formData = new FormData()
      formData.append('type', doc.typeCode)
      formData.append('file', doc.file)
      formData.append('BOLNumber', bolNumber)
      return axios.post(UPLOAD_DOCUMENT, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
    })
    return Promise.all(uploads)
      .then(() => { setPendingDocuments([]) })
      .catch(error => { checkErrorAPICall(error, dispatch, 'Upload Document') })
  }

  const createShipment = (streamlineAction: 'dispatch' | 'close' | null = null) => {
    let params = {}

    if(!isNaN(formik?.values?.pickupDate?.date) && formik?.errors?.pickupDate?.to !== 'Must be after from' && (!(formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length && !(formik.values?.shipper?.emails || [])?.filter(email => email?.includes('notanemail'))?.length && !(formik.values?.consignee?.emails || [])?.filter(email => email?.includes('notanemail'))?.length)){
      params = normalizeParamsShipment(formik.values, mode, selectedUn)
      let regex = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)

      if((regex.test(formik.values?.pickupDate?.from) || !formik.values?.pickupDate?.from) && (regex.test(formik.values.pickupDate.to) || !formik.values?.pickupDate?.to) && (regex.test(formik.values.deliveryDate?.from) || !formik.values?.deliveryDate?.from) && (regex.test(formik.values.deliveryDate?.to) || !formik.values?.deliveryDate?.to)){
        setLoadingCreateShipment(true)
        axios.post(CREATE_SHIPMENT, params).then(results => {
          setCreateOrUpdate('create')
          setLoadingCreateShipment(false)
          const bolResult = results.data.data?.results[0]
          const bolId = bolResult?.BOLId
          formik.setValues({
            ...formik.values,
            BOLNumber: bolResult?.BOLNmbr,
            BOLId: bolId,
            BOLPrefix: bolResult?.BOLPrefix,
          })
          bolDisplayRef.current = {
            prefix: bolResult?.BOLPrefix || '',
            number: bolResult?.BOLNmbr || '',
          }
          if(formik.values?.stops?.stops?.length){
            addStops(bolId)
          }
          const bolNumber = `${bolResult?.BOLPrefix || ''}${bolResult?.BOLNmbr || ''}`
          if (isStreamline && pendingDocuments.length > 0) {
            uploadPendingDocuments(bolNumber).then(() => {
              handleStreamlinePostSave(streamlineAction, {
                bolId,
                skipUpdate: streamlineAction === 'dispatch',
              })
            })
          } else {
            handleStreamlinePostSave(streamlineAction, {
              bolId,
              skipUpdate: streamlineAction === 'dispatch',
            })
          }
        }).catch(error => {
          setLoadingCreateShipment(false)
          if(error?.response?.data?.error?.message?.includes("Vendor not assigned")) {
            setOpenCarrierRequiredModal(true)
            return
          }
          checkErrorAPICall(error, dispatch, 'Create Shipment')
        })
      }
    }else{
      if((formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length || formik.values?.shipper?.emails?.filter(email => email?.includes('notanemail'))?.length || formik.values?.consignee?.emails?.filter(email => email?.includes('notanemail'))?.length){
        setOpenErrorsInPageModal(true)
      }

      if(isNaN(formik?.values?.pickupDate?.date)){
        formik.setFieldError('pickupDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
      }
    }
  }

  const updateShipment = (streamlineAction: 'dispatch' | 'close' | null = null) => {
    let params = {}

    if(!isNaN(formik?.values?.pickupDate?.date) && formik?.errors?.pickupDate?.to !== 'Must be after from'
    && (!(formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length && !(formik.values?.shipper?.emails || [])?.filter(email => email?.includes('notanemail'))?.length && !(formik.values?.consignee?.emails || [])?.filter(email => email?.includes('notanemail'))?.length)){
      params = normalizeParamsShipment(formik.values, mode, selectedUn)
      let regex = new RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/)

      if((regex.test(formik.values?.pickupDate?.from) || !formik.values?.pickupDate?.from) && (regex.test(formik.values.pickupDate.to) || !formik.values?.pickupDate?.to) && (regex.test(formik.values.deliveryDate?.from) || !formik.values?.deliveryDate?.from) && (regex.test(formik.values.deliveryDate?.to) || !formik.values?.deliveryDate?.to)){
        setLoadingUpdateShipment(true)
        const bolId = formik.values.BOLId
        axios.put(`${CREATE_SHIPMENT}/${bolId}`, params).then(results => {
          setCreateOrUpdate('update')
          setLoadingUpdateShipment(false)
          if(formik.values?.stops?.stops?.length){
            addStops(bolId)
          }
          const bolNumber = `${formik.values?.BOLPrefix || ''}${formik.values?.BOLNumber || ''}`
          if (isStreamline && pendingDocuments.length > 0) {
            uploadPendingDocuments(bolNumber).then(() => {
              handleStreamlinePostSave(streamlineAction, {
                bolId,
                skipUpdate: streamlineAction === 'dispatch',
              })
            })
          } else {
            handleStreamlinePostSave(streamlineAction, {
              bolId,
              skipUpdate: streamlineAction === 'dispatch',
            })
          }
        }).catch(error => {
          setLoadingUpdateShipment(false)
          if(error?.response?.data?.error?.message?.includes("Vendor not assigned")) {
            setOpenCarrierRequiredModal(true)
            return
          }
          checkErrorAPICall(error, dispatch, 'Update Shipment')
        })
      }
    }else{
      if((formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length || formik.values?.shipper?.emails?.filter(email => email?.includes('notanemail'))?.length || formik.values?.consignee?.emails?.filter(email => email?.includes('notanemail'))?.length){
        setOpenErrorsInPageModal(true)
      }

      if(isNaN(formik?.values?.pickupDate?.date)){
        formik.setFieldError('pickupDate.date', 'must be a `date` type, but the final value was: `Invalid Date` (cast from the value `Invalid Date`).')
      }
    }
  }

  const dispatchAction = (params, setLoading, bolId?: string | number) => {
    const id = bolId ?? formik.values.BOLId
    setLoadingDispatchShipment(true)
    axios.post(`${DISPATCH_SHIPMENT}/${id}`, {
      ...params
    }).then(results => {
      axios.get(`${DOCUMENTS}/${id}`).then(resultsDoc => {
        dispatch({type: actionTypes.SetOpenDispatchedModal, payload: true})
        dispatch({type: actionTypes.SetDispachedErrorMessage, payload:  results});
        const { prefix, number } = bolDisplayRef.current
        let documentsPayload = { 
          BOLNumber: customerInfo?.customerId == 2040011807 ? results.data.data.results.BOLCustom : `${prefix}${number}`,
          BOLDocumentURL: resultsDoc?.data?.data?.results?.filter(d => d?.name === 'Bill Of Lading')[0]?.url || "", 
          shipmentLabel: resultsDoc?.data?.data?.results?.filter(d => d?.name === 'Shipping Labels')[0]?.url || "", 
          carrierLabel: resultsDoc?.data?.data?.results?.filter(d => d?.name === 'Carrier Labels')[0]?.url || ""
        }      
        dispatch({
          type: actionTypes.SetDocuments,
          payload: documentsPayload
        })
        if(user?.allowTrack) {
          navigate('/trackings')
        }
        else {
          navigate('/home')
        }
        setLoading(false)
        setOpenPickupDatePastModal(false)
      })
    }).catch(error => {
      setLoadingDispatchShipment(false)

      if(error?.response?.data?.error?.message.includes("Collect Shipment errors")) {
        setOpenCollectInformationModal(true)
      }

      // Handle 409 error for NMFC required
      if(error?.response?.status === 409 && error?.response?.data?.error?.message?.includes("NMFC")) {
        setOpenNMFCRequiredModal(true)
        return
      }

      if(error?.response?.data?.error?.message?.includes("Vendor not assigned")) {
        setOpenCarrierRequiredModal(true)
        return
      }

      checkErrorAPICall(error, dispatch, 'Dispatch Shipment')
    })
  }

  const checkCarrierLabels = (bolId?: string | number) => {
    const id = bolId ?? formik.values.BOLId
    axios.get(`${CHECK_CARRIERLABELS}/${id}/options`)
    .then(results => {
      let callResults = results.data.data.results
      // With No Streamline and carrierWillGenerateLabels true, we open the carrier labeld package options modal
      if(callResults.carrierWillGenerateLabels && !isStreamline){
        setLoadingDispatchShipment(false)
        setSmallPackageOptions({dropToCarrier: callResults.dropToCarrier, pickupAlreadyScheduled: callResults.pickupAlreadyScheduled})
        setOpenSmallPackageOptionsModal(true)
      }
      // With Streamline
      else if(isStreamline){
        const selectedVendor = user.enabledVendors?.find(v => v.id === formik?.values?.carrierInformation?.vendorId)
        const carrierCode = formik?.values?.carrierInformation?.carrierCode
        const matchedSubVendor = selectedVendor?.subVendors?.find(sv => sv.carrierCode === carrierCode)
        const dispatchSetting = matchedSubVendor?.dispatchSetting ?? selectedVendor?.dispatchSetting
        if((!dispatchSetting || dispatchSetting == "AskUser")  && callResults.carrierWillGenerateLabels){
          // If the carrier is not dropping to carrier and the pickup is not already scheduled, we schedule the pickup
          if(!callResults.dropToCarrier && !callResults.pickupAlreadyScheduled) {
            dispatchAction({makeEDI: user?.allowEDI, smallPackageHandling: "Schedule Pickup"}, setLoadingDispatchShipment, id)
            return false
          }

          setLoadingDispatchShipment(false)
          setSmallPackageOptions({dropToCarrier: callResults.dropToCarrier, pickupAlreadyScheduled: callResults.pickupAlreadyScheduled})
          setOpenSmallPackageOptionsModal(true)
        } else {
          const formattedSetting = dispatchSetting?.replace(/([a-z])([A-Z])/g, '$1 $2')?.toUpperCase()
          dispatchAction({makeEDI: user?.allowEDI, smallPackageHandling: formattedSetting}, setLoadingDispatchShipment, id)
        }
      }
      else{
        // With No Streamline and carrierWillGenerateLabels false, we dispatch the shipment
        dispatchAction({makeEDI: user?.allowEDI}, setLoadingDispatchShipment, id)
      }
    }).catch(error => {
      setLoadingDispatchShipment(false)
    })
  }

  const buildDispatchStops = () => {
    let regexDate = new RegExp(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)

    return formik.values?.stops?.stops?.map((stop) => {
      return ({
        "stopNumber": stop?.stopNumber,
        "reference": stop?.reference,
        "pickupDelivery": stop?.type,
        "pickupDeliveryDate": stop?.date ? (!regexDate.test(stop?.date) ? format(stop?.date || null, 'yyyy-MM-dd') : stop?.date) : '',
        "pickupDeliveryTimeFrom": stop?.from,
        "pickupDeliveryTimeTo": stop?.to,
        "name": stop?.name,
        "address1": stop?.address,
        "address2": stop?.address1,
        "city": stop?.city,
        "cityAlias": stop?.city,
        "state": stop?.state,
        "zipcode": stop?.zipcode,
        "country": stop?.country,
        "phone": stop?.phone,
        "fax": "",
        "email": "",
        "contact": stop?.contact,
        "contactPhone": stop?.contactPhone,
        "notes": stop?.notes,
        "PODDate": stop?.PODDate ? (!regexDate.test(stop?.PODDate) ? format(stop?.PODDate || null, 'yyyy-MM-dd') : stop?.PODDate) : '',
        "signedBy": stop.signedBy
      })
    })
  }

  const postStopsAndDispatch = (bolId: string | number) => {
    const stops = buildDispatchStops()
    axios.post(`${ADD_STOPS}/${bolId}/stops`, {stops: stops}).then(results => {
      if(formik.values.pickupDate?.date?.setHours(0,0,0,0) < new Date()?.setHours(0,0,0,0)){
        setLoadingDispatchShipment(false)
        setOpenPickupDatePastModal(true)
      }else{
        // "If it's a collect shipment, we're not calling the OPTIONS, just triggering the dispatch"
        if(!formik.values.collect) {
          checkCarrierLabels(bolId)
        }
        else {
          dispatchAction({makeEDI: user?.allowEDI}, setLoadingDispatchShipment, bolId)
        }
      }
    }).catch(error => {
      setLoadingDispatchShipment(false)
      checkErrorAPICall(error, dispatch, 'Update Shipment')
    })
  }

  const dispatchShipment = (options: DispatchOptions = {}) => {
    const bolId = options.bolId ?? formik.values.BOLId
    if (!bolId) {
      setLoadingDispatchShipment(false)
      return
    }

    if (options.skipUpdate) {
      postStopsAndDispatch(bolId)
      return
    }

    const params = normalizeParamsShipment(formik.values, mode, selectedUn)
    axios.put(`${CREATE_SHIPMENT}/${bolId}`, params).then(results => {
      postStopsAndDispatch(bolId)
    }).catch(error => {
      setLoadingDispatchShipment(false)
      checkErrorAPICall(error, dispatch, 'Update Shipment')
    })
  }

  const executeDispatchAfterSave = (options: DispatchOptions = {}) => {
    submitButtonLet = 'book'
    setSubmitButton('book')
    setLoadingDispatchShipment(true)
    dispatchShipment(options)
  }

  const getDocuments = () => {
    axios.get(`${DOCUMENTS}/${formik.values?.BOLId}`).then(results => {
      setDocuments(results.data.data.results)
      setLoadingDocuments(false)
      setOpenDocumentsModal(true)
    }).catch(error => {
      setLoadingDocuments(false)
      checkErrorAPICall(error, dispatch, 'Get Documents')
    })
  }

  const keepWaitingVendors = () => {
    let array = [...(rates || [])]
    let progress = linearProgress
    let callsFinishedLocal = 0
    const enabledVendorsFiltered = [...vendorsTimedOut] 
    let vendorsProcessedLocal = vendorsProcessed
    let vendorsTimedOutLocal = []

    setRatesStopped(false)
    source = cancelToken.source()

    enabledVendorsFiltered.forEach((vendor) => {
      axios.get(!vendor?.carrierCode ? GET_RATES : GET_RATES_SUB_VENDOR, {
        cancelToken: source.token,
        params: !vendor?.carrierCode ? normalizeParams(formik.values, vendor.id, mode, selectedUn) : {carrierCode: vendor?.carrierCode, ...normalizeParams(formik.values, vendor.id, mode, selectedUn)},
        timeout: 30000,
      }).then(response => {
        response.data.data.results?.filter(result => !result.error).forEach((newRate) => {
          if(newRate.SCAC && user.SCACFilteringEnabled){
            let duplicated = array.find(oldRate => oldRate?.SCAC === newRate?.SCAC && oldRate?.serviceLevel.toLowerCase() === newRate?.serviceLevel.toLowerCase() && oldRate.id !== newRate.id) || {} as any

            let vendorNew = enabledVendorsFiltered?.find(vendor => vendor?.id === newRate?.vendorId)
            let vendorDuplicated = duplicated.vendorId ? enabledVendorsFiltered.find(vendor => vendor?.id === duplicated?.vendorId) : {id: '', is3PL: false, isDirectAccount: false}
  
            let eliminateDuplicated = array.filter(rate => JSON.stringify(rate) !== JSON.stringify(duplicated))
            let eliminateNew = array.filter(rate => JSON.stringify(rate) !== JSON.stringify(newRate))
  
            if(vendorNew?.id && vendorDuplicated?.id){
              if(vendorNew.is3PL && (!vendorDuplicated.is3PL && duplicated.total >= newRate.total)){
                array = [...eliminateDuplicated, newRate]
              }else if(vendorNew.is3PL && vendorDuplicated.is3PL){
                if(newRate.total >= duplicated.total){
                  array.push(duplicated)
                  array = eliminateNew
                }else{
                  array = [...eliminateDuplicated, newRate]
                }
              }else if(vendorNew.isDirectAccount && vendorDuplicated.isDirectAccount){
                if(newRate.total >= duplicated.total){
                  array.push(duplicated)
                  array = eliminateNew
                }else{
                  array.push(newRate)
                  array = eliminateDuplicated
                }
              }else if(vendorNew.is3PL && vendorDuplicated.isDirectAccount){
                if(duplicated.total > (newRate.total + parseFloat(user.SCACFilteringVarianceUSD)) && duplicated.total > (newRate.total * (1 + (parseFloat(user.SCACFilteringVariancePercentage) / 100)))){
                  array.push(newRate)
                  array = eliminateDuplicated
                }else{
                  array.push(duplicated)
                  array = eliminateNew
                }
              }else if(vendorNew.isDirectAccount && vendorDuplicated.is3PL){
                if(newRate.total <= (duplicated.total + parseFloat(user.SCACFilteringVarianceUSD)) && newRate.total <= (duplicated.total * (1 + (parseFloat(user.SCACFilteringVariancePercentage) / 100)))){
                  array.push(newRate)
                  array = eliminateDuplicated
                }else{
                  array.push(duplicated)
                  array = eliminateNew
                }
              }
            }else{
              array.push(newRate)
            }
          }else{
            array.push(newRate)
          }
        })

        setRates([
          ...array
        ])
        
        progress = progress + (100 / enabledVendors.length)
        setLinearProgress(progress)
        vendorsProcessedLocal = (parseInt(vendorsProcessedLocal) + 1).toString()
        setVendorsProcessed(vendorsProcessedLocal)
      }).catch(error => {
        if(error.toString().includes('timeout')){
          vendorsTimedOutLocal = [...vendorsTimedOutLocal, vendor]
          setVendorsTimedOut(vendorsTimedOutLocal)
        }else if(error.message !== 'Operation canceled by the user.'){
          progress = progress + (100 / enabledVendors.length)
          setLinearProgress(progress)
          vendorsProcessedLocal = (parseInt(vendorsProcessedLocal) + 1).toString()
          setVendorsProcessed(vendorsProcessedLocal)
        }

        if(error?.response?.data?.error?.message.length){
          if(error?.response?.status === 401){
            setRatesStopped(true)
            isTokenExp()
          }
        }
      }).finally(() => {
        callsFinishedLocal = callsFinishedLocal + 1
        if(callsFinishedLocal === (enabledVendorsFiltered.length)){
          if(vendorsTimedOutLocal?.length){
            setOpenConfirmTimedOutModal(true)
          }
          setRatesStopped(true)
        }
      })
    })
  }

  const formik = useFormik({
    initialValues,
    validationSchema: () => validationSchema({dispatchShipment: submitButtonLet === 'book' ? true : false, mode: mode, requireDimensions: user.requireDimensions, formikValues: formik.values}),
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: false,
    
    onSubmit: (values, formikBag) => {
      formikBag.setErrors({})
      setOpenErrorsInPageModal(false)

      if(submitButton === 'book'){
        setLoadingDispatchShipment(true)
        if([...formik?.values?.accessorials?.origin, ...formik?.values?.accessorials?.destination, ...formik?.values?.accessorials?.other].filter(a => a.code === 'INS')?.length && !formik?.values?.accessorials?.other?.filter(a => a.code === 'INS' && (a.insuranceAmount || formik.values.insuranceAmount)).length ){        
          setOpenInsuranceRequiredModal(true)
        }else{
          if(formik?.errors?.pickupDate?.to === 'Must be after from'){
            setLoadingDispatchShipment(false)
            setOpenErrorsInPageModal(true)
          }else{
            if(formik?.values?.carrierInformation?.rateId || formik?.values?.carrierInformation?.name || (formik?.values?.selectedVendorCollect && formik?.values?.collectVendorId)){
              // Check if vendor requires NMFC
              const selectedVendor = user.enabledVendors?.find(v => v.id === formik?.values?.carrierInformation?.vendorId)
              const requiresNMFC = selectedVendor?.requirePickupNMFC
              const allFreightHaveNMFC = formik?.values?.freightInfo?.every(freight => freight?.nmfc && freight?.nmfc?.trim() !== '')

              if(requiresNMFC && !allFreightHaveNMFC){
                setLoadingDispatchShipment(false)
                setOpenNMFCRequiredModal(true)
              }else{
                dispatchShipment()
              }
            }else{
              setLoadingDispatchShipment(false)

              if(isCollect && values?.selectedVendorCollect && !values.collectVendorId) {
                setOpenCollectVendorSetup(true)
              }
              else {
                setOpenCarrierRequiredModal(true)
              }

              if(isCollect && !values?.selectedVendorCollect) {
                formik.setFieldError('selectedVendorCollect', "required")
              }
            }
          }
        }
      }
      else if(submitButton === 'quote'){

        if([...formik?.values?.accessorials?.origin, ...formik?.values?.accessorials?.destination, ...formik?.values?.accessorials?.other].filter(a => a.code === 'INS')?.length && !formik?.values?.accessorials?.other?.filter(a => a.code === 'INS' && (a.insuranceAmount || formik.values.insuranceAmount)).length ){
            setOpenInsuranceRequiredModal(true)        
        }else{

      if(values.pickupDate.date){
              let enabledVendorsFiltered = []
              // Match GetQuote logic: include all vendor types (LTL, VOL, 3PL, GRE, SP, AIR, INTL)
              enabledVendorsFiltered = user?.enabledVendors.filter(vendor =>
                vendor?.type === 'LTL' ||
                vendor?.type === 'VOL' ||
                vendor?.type === '3PL' ||
                vendor?.type === 'GRE' ||
                vendor?.type === 'SP' ||
                vendor?.type === 'AIR' ||
                vendor?.type === 'INTL' ||
                vendor?.type === 'DRAY'
              )
              // Match GetQuote logic: ONLY if no main vendors found, then search subVendors
              if(!enabledVendorsFiltered.length){
                let subVendors = []
                user.enabledVendors.forEach((vendor: any) => {
                  // SP subVendors
                  let subVendorsSP = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'SP')
                  if(subVendorsSP?.length){
                    subVendors.push(...subVendorsSP)
                  }
                  // GRE subVendors
                  let subVendorsGRE = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'GRE')
                  if(subVendorsGRE?.length){
                    subVendors.push(...subVendorsGRE)
                  }
                  // LTL/3PL subVendors
                  let subVendorsLTL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'LTL' || subVendor?.carrierType === '3PL')
                  if(subVendorsLTL?.length){
                    subVendors.push(...subVendorsLTL)
                  }
                  // VOL subVendors
                  let subVendorsVOL = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'VOL')
                  if(subVendorsVOL?.length){
                    subVendors.push(...subVendorsVOL)
                  }
                  // AIR/INTL subVendors
                  let subVendorsAIR = vendor?.subVendors?.map(subVendor => ({...subVendor, id: vendor.id})).filter(subVendor => subVendor?.carrierType === 'INTL' || subVendor?.carrierType === 'AIR')
                  if(subVendorsAIR?.length){
                    subVendors.push(...subVendorsAIR)
                  }
                })
                enabledVendorsFiltered = subVendors
              }
            if(enabledVendorsFiltered?.length){
              setOpenRatesModal(true)
              source = cancelToken.source()
              // Fetch the lane distance first (mirrors GetQuote) so we can send laneDistance to the rate/p2p endpoints
              axios.get(GET_LANEDISTANCE, {params: {
                'origins[]': values.shipper.zipcode,
                'destinations[]': values.consignee.zipcode,
                units: 'imperial'
              }})
                .then(response => response.data.data.results?.length ? response.data.data.results[0]?.distance?.valueInMiles : undefined)
                .catch(() => undefined)
                .then(laneDistance => {
                  // Store it in formik too so the "keep waiting" retry path (keepWaitingVendors) also sends it
                  formik.setFieldValue('laneDistance', laneDistance)
                  // Pass toggles as true to match GetQuote behavior in getRatesWithLimit
                  getRatesWithLimit({...values, mode, VOL: true, LTL: true, smallPack: true, AIR: true, expedite: true}, selectedAcc, enabledVendorsFiltered, setEnabledVendors, setVendorsProcessed, setVendorsTimedOut, setOpenConfirmTimedOutModal, user, () => {}, setRates, setLinearProgress, setRatesStopped, source, (vendorId, lnft, laneDistanceParam) => normalizeParams(formik.values, vendorId, mode, selectedUn, laneDistanceParam), selectedUn, '', undefined, laneDistance)
                })
            }else{
                if(isCollect && values?.selectedVendorCollect && !values.collectVendorId) {
                  setOpenCollectVendorSetup(true)
                }
                else {
                  setOpenNoVendorsSetUpModal(true)
                }
            }
          }else{
            formik.setFieldError('pickupDate.date', "pickupDate.date must be a `date` type, but the final value was: `Invalid Date`.")
            }
          }         
      }
    }
  })

  const formikDispatch = useFormik({
    initialValues: formik.values,
    validationSchema: () => validationSchema({dispatchShipment: true, mode: mode, requireDimensions: user.requireDimensions, ...formik.values}),
    validateOnChange: false,
    onSubmit: (values, formikBag) => {
      formikBag.setErrors({})
      setOpenErrorsInPageModal(false)

    }
  })
  
  const trackingAction = () => {
    setLoadingTracking(true)
    axios.get(`${HISTORYTRACKINGS}/${formik.values?.BOLId}`).then(results => {
        setLoadingTracking(false)
        const resultsWithID = results.data.data.results.map(result => {
            return ({
                ...result,
                id: uuidv4()
            })
        })
        setHistoryTrackings(resultsWithID)
        setOpenTrackingModal(true)
    }).catch(error => {
        setLoadingTracking(false)
        checkErrorAPICall(error, dispatch, 'History Tracking')
    })
  }

  const getShipmentMode = (values) => {
    axios.get((SHIPMENT_MODES)).then((result) => {
      let shipmentMode
      // let type
      // if(values?.carrierInformation?.vendorId) {
      //   type = user.enabledVendors.find(vendor => vendor.id === values?.carrierInformation?.vendorId)?.type

      //   if(type){
      //     shipmentMode = result.data.data.results?.find(mode => mode.code === type)
      //   }else{
      //     shipmentMode = result.data.data.results?.find(mode => mode.name === values?.modeName)
      //   }
      // }
      if(values?.modeName) {
        shipmentMode = result.data.data.results?.find(mode => mode.name === values?.modeName)
      }else if(values.mode || values.mode === ''){
        shipmentMode = result.data.data.results?.filter(mode => mode.shipmentCategory === values?.mode).find(mode => mode.name === values?.modeName)
      }else if(values?.fromBatchBooking && values?.carrierInformation?.vendorId){
        shipmentMode = user.enabledVendors.find(vendor => vendor.id === values?.carrierInformation?.vendorId)?.shipmentMode
      }

      setModes(result.data.data.results)
      if(values.length !== 0){
        if(shipmentMode?.id === 0 || shipmentMode?.id){
          setMode(shipmentMode)
          setModeLocal(shipmentMode.name)
        } else if(user?.defaultShipmentMode?.name) {
            setMode(user.defaultShipmentMode)
            setModeLocal(user?.defaultShipmentMode.name)
        }
        else{
          setMode(result.data.data.results?.find((mode) => mode.id === 0))
          setModeLocal(result.data.data.results?.find((mode) => mode.id === 0).name)
        }
      }
      else{
        setMode(result.data.data.results?.find((mode) => mode.id === 0))
        setModeLocal(result.data.data.results?.find((mode) => mode.id === 0).name)
      }
    })
  }

  const getShipmentModeQuote = (values) => {
    axios.get((SHIPMENT_MODES)).then((result) => {      
      let selectedVendor
      
      setModes(result.data.data.results)

      if(values?.carrierInformation?.vendorId) {
        selectedVendor = user.enabledVendors.find(vendor => vendor.id === values?.carrierInformation?.vendorId)
        if(selectedVendor?.shipmentMode?.name) {
          if(newBookingValues.mode && 
            user?.defaultShipmentMode?.name == selectedVendor?.shipmentMode?.name 
            && newBookingValues.mode.toUpperCase() != user?.defaultShipmentMode?.name
          ) {
            return false         
          }
          else {
            if(selectedVendor?.shipmentMode && formik.values.carrierInformation.vendorId !== newBookingValues.carrierInformation.vendorId) {
              setMode(selectedVendor?.shipmentMode)
              setModeLocal(selectedVendor?.shipmentMode?.name)
              return false
            }
            if(newBookingValues.mode && !newBookingValues.isBookingDuplicated) {
              let shipmentMode = result.data.data.results?.find(mode => mode.name === values?.modeName)
              if(shipmentMode) {
                setMode(shipmentMode)              
                setModeLocal(shipmentMode.name)
              }
              else {
                return false
              }
            }
            else {
              setMode(selectedVendor?.shipmentMode)
              setModeLocal(selectedVendor?.shipmentMode?.name)
            }
          }
        }
        else {
          setMode(result.data.data.results?.find((mode) => mode.id === 0))
          setModeLocal(result.data.data.results?.find((mode) => mode.id === 0).name)
        }
      }
      else {
        setMode(result.data.data.results?.find((mode) => mode.id === 0))
        setModeLocal(result.data.data.results?.find((mode) => mode.id === 0).name)
      }
    })
  }

  const setCollectData = async (vendor) => {
    formik.setFieldValue('selectedVendorCollect', vendor?.name)
    formik.setFieldValue('collectVendorId', vendor?.id)
    if(vendor.showBOLInstructions) {
      formik.setFieldValue('specialInstructions', formik?.values?.specialInstructions?.concat("\r\n\r\n", vendor.notesBOL?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&")))
    }
    else {
      formik.setFieldValue('specialInstructions', user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, ""))
    }
  }

  const getCollectData = async () => {
    if(!vendorsCollect.length) {
      await axios.get(`${VENDORS_COLLECT}`)
      .then(results => {
        if(isMountedRef.current) {
          setVendorsCollect(results.data.data.results)
          let foundedItem = results.data.data.results.find(item => item.name === newBookingValues.collectVendorName);
          
          if(foundedItem) {
            formik.setFieldValue('selectedVendorCollect', foundedItem?.name)
            formik.setFieldValue('collectVendorId', foundedItem?.id)
          }

          if(!foundedItem && newBookingValues?.collectVendorName) {
            formik.setFieldValue('selectedVendorCollect', newBookingValues.collectVendorName)
            formik.setFieldValue('collectVendorName', newBookingValues.collectVendorName)
          }
        }
      }).catch(error => {
        if(isMountedRef.current) {
          console.log(error)
        }
      })
    }
  }

  const fillBookingData = () => {
    const locationData: any = {}
      
      const locations = ['shipper', 'consignee'];
      locations.forEach((location) => {
        if(newBookingValues && newBookingValues[location] && (newBookingValues[location]['address2'] || newBookingValues[location]['address2'] === '')){
          newBookingValues[location]['address'] = newBookingValues[location]['address1'];
          newBookingValues[location]['address1'] = newBookingValues[location]['address2'];
          delete newBookingValues[location]['address2'];
        }
        
        locationData[location] = {
          name: newBookingValues[location]?.name || "",
          address: newBookingValues[location]?.address || "",
          address1: newBookingValues[location]?.address1 || "",
          phone: formatPhone(newBookingValues[location]?.phone, newBookingValues[location]?.country || "US") || "",
          contact: newBookingValues[location]?.contact || "",
          contactPhone: formatPhone(newBookingValues[location]?.contactPhone, newBookingValues[location]?.country || "US") || "",
          emails: calculateEmail(newBookingValues[location]?.email),
          id: newBookingValues[location]?.id || "",
          city: newBookingValues[location]?.city || "",
          country: newBookingValues[location]?.country || "US",
          state: newBookingValues[location]?.state || "",
          zipcode: newBookingValues[location]?.zipcode || newBookingValues[location]?.zipCode || "",
          referenceNumber: newBookingValues[location].referenceNumber,
          IATACode: newBookingValues[location].IATACode,
          tradeShow: newBookingValues[location].tradeShow
        }
      })

      // Preparar freightInfo
      const freightInfo = newBookingValues?.freightInfo?.length
        ? newBookingValues?.freightInfo?.map((freight) => {
          const dimTypeAsContainer = typeof freight?.dimType === 'string' || typeof freight?.dimType === 'number'
            ? Number(freight.dimType)
            : null
          return {
            ...freight,
            freightsnapId: freight?.freightSnapId ?? freight?.freightsnapId ?? null,
            container: freight?.container || dimTypeAsContainer || 20,
            stack: false,
            stackAmount: freight?.stackAmount > 1 ? freight?.stackAmount : null,
            overrideClass: !freight?.overrideClass
          }
        })
        : [{
          id: uuidv4(),
          qty: '',
          dimType: {
          name: "PALLET",
          value: "PLT"
          },
          container: 20,
          STC: '',
          weight: '',
          each: 'Each',
          L: '',
          W: '',
          H: '',
          class: '',
          commodity: '',
          nmfc: '',
          weightus: '',
          Lus: '',
          Wus: '',
          Hus: '',
          totalCft: '',
          hazmat: false,
          UN: ''
        }]

      // Preparar símbolo UOM
      const uomSymbol = newBookingValues?.freightInfoUOM.value ? (newBookingValues?.freightInfoUOM.value === 'US' ? 'lbs' : 'kgs') : user?.defaultUOM === 'US' ? 'lbs' : 'kgs'

      // Preparar accessorials
      let accessorial: any[] = []
      if(newBookingValues?.accessorials?.length){
        newBookingValues?.accessorials?.forEach((acc) => {
          if(user?.enabledAccessorials?.filter(enabledAcc => enabledAcc?.code === acc)[0]){
            accessorial.push(user?.enabledAccessorials?.filter(enabledAcc => enabledAcc?.code === acc)[0])
          }
        })
      }else{
        accessorial = [...(newBookingValues?.accessorials?.origin ? newBookingValues?.accessorials?.origin : []), ...(newBookingValues?.accessorials?.destination ? newBookingValues?.accessorials?.destination : []), ...(newBookingValues?.accessorials?.other ? newBookingValues?.accessorials?.other : [])]
      }
      setSelectedAcc(accessorial)

      // Preparar otherInfo
      let otherInfo = formik?.values?.otherInfo
      if(newBookingValues?.fromSearch){
        otherInfo = {
          ...formik?.values?.otherInfo,
          broker: {
            ...formik?.values?.otherInfo?.broker,
            name: newBookingValues?.brokerInformation?.name || '',
            contact: newBookingValues?.brokerInformation?.contact || '',
            phone: formatPhone(newBookingValues?.brokerInformation?.phone, 'US'),
            instructions: newBookingValues?.brokerInformation?.notes || '',
          },
          BKGRefNumber: newBookingValues?.additionalInformation.BKGRef,
          BKGValue: newBookingValues?.brokerInformation.customValue,
          refNumber1: newBookingValues?.additionalInformation?.shipmentReference1,
          refNumber2: newBookingValues?.additionalInformation?.shipmentReference2,
          incoTerm: newBookingValues?.additionalInformation?.incoTerm,
          dutyAndTaxPayableBy: newBookingValues?.additionalInformation?.dutyAndTaxPayableBy || '',
          receiverAccountNumber: newBookingValues?.additionalInformation?.receiverAccountNumber || '',
          exportFiling: newBookingValues?.additionalInformation?.exportFiling || '',
          itnNumber: newBookingValues?.additionalInformation?.ITNNumber || '',
          ftrExemptionCode: newBookingValues?.additionalInformation?.FTRExemption || '',
          dhlNotificationEmail: newBookingValues?.additionalInformation?.DHLNotificationEmail || '',
          paperlessTrade: newBookingValues?.additionalInformation?.paperlessTrade || false,
          dutiesPaid: newBookingValues?.additionalInformation?.dutiesPaid || false,
        }
      } else {
        otherInfo = {
          ...formik?.values?.otherInfo,
          broker: {
            ...formik?.values?.otherInfo?.broker,
            name: newBookingValues?.brokerInformation?.name || '',
            contact: newBookingValues?.brokerInformation?.contact || '',
            phone: formatPhone(newBookingValues?.brokerInformation?.phone, 'US'),
            instructions: newBookingValues?.brokerInformation?.notes || '',
          }
        }
      }

      // Preparar stops
      const stops = {
        stops: formik.values?.stops?.stops?.length ? formik.values?.stops?.stops : [],
        serviceType: newBookingValues?.stopsInformation?.serviceType || 'EXCLUSIVE',
        equipment: newBookingValues?.stopsInformation?.equipments?.map((a: any) => a.id) || [],
        length: newBookingValues?.stopsInformation?.equipmentLength || '',
      }

      // Preparar billTo emails
      let billToEmails = formik.values.billTo.emails
      if(!newBookingValues.BOLId) {
        billToEmails = calculateEmail(newBookingValues?.thirdParty?.email)
      }

      // Construir objeto con todos los valores
      const newFormikValues = {
        ...formik.values,
        shipper: locationData.shipper,
        consignee: locationData.consignee,
        carrierInformation: newBookingValues?.carrierInformation,
        freightInfo: freightInfo,
        freightInfoUOM: {
          value: newBookingValues?.freightInfoUOM.value || user?.defaultUOM,
          oldValue: newBookingValues?.freightInfoUOM.oldValue || ''
        },
        freightInfoTotals: {
          ...formik.values.freightInfoTotals,
          symbol: uomSymbol
        },
        quoteNumber: !newBookingValues?.collect ? newBookingValues.quoteNumber : formik.values.quoteNumber,
        selectedVendorCollect: !newBookingValues?.collect ? (newBookingValues?.selectedVendorCollect || '') : '',
        dispatched: newBookingValues.dispatched || false,
        BOLNumber: newBookingValues?.BOLNumber,
        PRONmbr: newBookingValues?.PRONmbr,
        BOLPrefix: newBookingValues?.BOLPrefix || (isStreamline ? user?.office?.prefix : '') || '',
        BOLId: newBookingValues?.BOLId,
        billTo: {
          ...formik.values.billTo,
          referenceNumber: newBookingValues?.thirdPartyReferenceNumber,
          emails: billToEmails
        },
        shipmentNotes: newBookingValues?.shipmentNotes,
        isBookingDuplicated: newBookingValues.isBookingDuplicated,
        bookingIdCopiedFrom: newBookingValues.bookingIdCopiedFrom,
        reversedBooking: newBookingValues.reversedBooking,
        specialInstructions: newBookingValues?.fromSearch ? newBookingValues?.specialInstructions : formik.values.specialInstructions,
        otherInfo: otherInfo,
        pickupDate: newBookingValues?.pickupDate,
        deliveryDate: newBookingValues?.deliveryDate,
        moneyAccessorialsInformation: newBookingValues?.moneyAccessorialsInformation,
        emergencyContact: newBookingValues?.emergencyContact,
        emergencyPhone: newBookingValues?.emergencyPhone,
        stops: stops,
        insuranceAddOn: newBookingValues?.insuranceAddOn || formik.values.insuranceAddOn,
        insuranceAmount: newBookingValues?.insuranceAmount || formik.values.insuranceAmount,
        insuranceFreight: newBookingValues?.insuranceFreight || formik.values.insuranceFreight,
        commodityInsurance: newBookingValues?.commodityInsurance || formik.values.commodityInsurance,
        redkikQuoteId: (newBookingValues?.redkikQuoteId && user?.redkikEnabled && !newBookingValues?.insuranceFreight) ? newBookingValues?.redkikQuoteId : formik.values.redkikQuoteId,
        collect: newBookingValues?.collect || '',
        collectQuoteNumber: newBookingValues?.collect ? newBookingValues.quoteNumber : '',
        collectQuoteAmount: newBookingValues?.collect ? newBookingValues.collectQuoteAmount : '',
        coverTypeInsurance: newBookingValues?.coverTypeInsurance || '',
        billToData: newBookingValues?.collect ? newBookingValues?.billToData : ''
      }

      // Actualizar estado de collect
      if(newBookingValues?.collect) {
        setIsCollect(true)
      } else {
        setIsCollect(false)
      }

      // Realizar una única actualización con setValues
      formik.setValues(newFormikValues)

      // Fetch HAZ contact if shipper has id but emergencyContact is not set
      if(locationData.shipper.id && !newBookingValues?.emergencyContact){
        axios.get(GET_CONTACTS, {
          params: { shippingLocationId: locationData.shipper.id }
        }).then(results => {
          const contacts = results.data.data.results
          const hazContact = contacts?.find(contact => contact.type === "Emergency/Haz")
          if(hazContact){
            formik.setFieldValue('emergencyContact', `${hazContact.firstName} ${hazContact.lastName}`)
            formik.setFieldValue('emergencyPhone', hazContact.phone)
          }
        }).catch(() => {})
      }

      // Ejecutar la llamada a redkik si es necesario
      if(newBookingValues?.commodityInsurance && user?.redkikEnabled && !newBookingValues?.insuranceFreight) {
        axios.post(CREATE_QUOTE_REDKIK, {
          originCity: newBookingValues.shipper?.city,
          originState: newBookingValues.shipper?.state,
          originZipcode: newBookingValues.shipper?.zipcode,
          originCountry: newBookingValues.shipper?.country,
          destinationCity: newBookingValues.consignee?.city,
          destinationState: newBookingValues.consignee?.state,
          destinationZipcode: newBookingValues.consignee?.zipcode,
          destinationCountry: newBookingValues.consignee?.country,
          commodityInsurance: newBookingValues?.commodityInsurance,
          insuranceAmount: newBookingValues?.insuranceAmount,
          insuranceFreight: newBookingValues?.insuranceFreight,
          insuranceAddOn: newBookingValues?.insuranceAddOn,
          coverTypeInsurance: newBookingValues?.coverTypeInsurance || null,
          pickupDate: newBookingValues.pickupDate?.date ? new Date(newBookingValues.pickupDate?.date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10),
          conveyanceType: "LAND"
        }).then(result => {
          if(result.data.data.results.redkikQuoteId) {
            formik.setFieldValue('redkikQuoteId', result.data.data.results.redkikQuoteId)
          }
        }).catch(error => {
          // Handle error silently
        })
      }
  }

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    setIsStreamline(!!user?.enableDispatchStreamline)
  }, [user?.enableDispatchStreamline])

  useEffect(() => {
    if (formik.values.BOLNumber) {
      bolDisplayRef.current = {
        prefix: formik.values.BOLPrefix || '',
        number: formik.values.BOLNumber,
      }
    }
  }, [formik.values.BOLPrefix, formik.values.BOLNumber])

  useEffect(() => {
    getCollectData()
    if(!isCollect) {
      formik.setFieldValue('collectQuoteNumber', '')
      formik.setFieldValue('collectVendorId', '')
      formik.setFieldValue('collect', '')
    }
    else {
      formik.setFieldValue(`carrierInformation`, {})
      formik.setFieldValue(`url`, '')
      formik.setFieldValue(`quoteNumber`, '')
      formik.setFieldValue(`vendorId`, '')
      formik.setFieldValue(`vendorSCAC`, '')
    }
  }, [isCollect])

  useEffect(() => {
    formik.setFieldValue(`accessorials.origin`, selectedAcc?.filter(acc => acc.category === 'Origin'))
    formik.setFieldValue(`accessorials.destination`, selectedAcc?.filter(acc => acc.category === 'Destination'))
    formik.setFieldValue(`accessorials.other`, selectedAcc?.filter(acc => acc.category === 'Other'))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAcc])

  useEffect(() => {
    if(quoteValues.length !== 0){
      formik.setFieldValue(`shipper`, {
        ...formik.values.shipper,
        country: quoteValues.origin?.isPort ? 'US' : quoteValues?.origin?.Country || 'US',
        city: quoteValues?.origin?.City,
        state: quoteValues?.origin?.State,
        zipcode: quoteValues?.origin?.Zipcode,
        name: quoteValues?.origin?.Name || '',
        isPort: quoteValues?.origin?.isPort || false,
        IATACode: quoteValues?.origin?.IATA || quoteValues?.origin?.IATACode || ''
      })
      formik.setFieldValue(`consignee`, {
        ...formik.values.consignee,
        country: quoteValues.destination?.isPort ? 'US' : quoteValues?.destination?.Country || 'US',
        city: quoteValues?.destination?.City,
        state: quoteValues?.destination?.State,
        zipcode: quoteValues?.destination?.Zipcode,
        name: quoteValues?.destination?.Name || '',
        isPort: quoteValues?.destination?.isPort || false,
        IATACode: quoteValues?.destination?.IATA || quoteValues?.destination?.IATACode || ''
      })

      setSelectedUn(quoteValues?.selectedUn || [])

      
      if(quoteValues?.moneyAccessorialsInformation) {
        formik.setFieldValue(`moneyAccessorialsInformation`, quoteValues?.moneyAccessorialsInformation)
      }
      // else if(quoteValues?.accessorials?.other.length > 0) {
      //   formik.setFieldValue(`moneyAccessorialsInformation`, quoteValues?.accessorials.other)
      // }

      formik.setFieldValue(`freightInfo`, quoteValues?.freightInfo?.map((quote, index) => {
        if(quoteValues?.mode === 'Drayage'){
          return {
            ...quote,
            freightsnapId: quote?.freightSnapId ?? quote?.freightsnapId ?? null,
            accessorials: quote?.accessorials?.length ? quote?.accessorials?.map((acc) => {
              if(acc === 'HAZ'){
                return 'Hazmat'
              }else if(acc === 'REEF'){
                return 'Reefer'
              }else if(acc === 'RESI'){
                return 'Residential Delivery'
              }else if(acc === 'HOGO'){
                return 'Household Goods'
              }else if(acc === 'OWT'){
                return 'Overweight'
              }else{
                return ''
              }
            }) : [],
            class: quoteValues?.freightInfoReclassed[index]?.class?.toString() || quote?.class,
            overrideClass: quoteValues?.freightInfoReclassed[index]?.class ? false : quote?.overrideClass,
          }
        }else{
          return {
            ...quote,
            freightsnapId: quote?.freightSnapId ?? quote?.freightsnapId ?? null,
            overrideClass: quoteValues?.freightInfoReclassed[index]?.class ? false : quote?.overrideClass,
            class: quoteValues?.freightInfoReclassed[index]?.class?.toString() || quote?.class
          }
        }
      }))

      formik.setFieldValue('freightInfoUOM.value', quoteValues?.freightInfoUOM?.value || user?.defaultUOM)
      formik.setFieldValue('freightInfoUOM.oldValue', quoteValues?.freightInfoUOM?.oldValue || '')
      formik.setFieldValue('freightInfoTotals.symbol', quoteValues?.freightInfoUOM?.value ? (quoteValues?.freightInfoUOM?.value === 'US' ? 'lbs' : 'kgs') : (user?.defaultUOM === 'US' ? 'lbs' : 'kgs'))

      formik.setFieldValue(`pickupDate.date`, quoteValues?.pickupDate || null)

      formik.setFieldValue(`pickupDate.from`, quoteValues?.origin?.OpenTime || quoteValues?.origin?.opentime || newBookingValues?.pickupDate?.from)
      formik.setFieldValue(`pickupDate.to`, quoteValues?.origin?.CloseTime || quoteValues?.origin?.closetime || newBookingValues?.pickupDate?.to)

      formik.setFieldValue(`deliveryDate.from`, quoteValues?.destination?.OpenTime || quoteValues?.destination?.opentime || null)
      formik.setFieldValue(`deliveryDate.to`, quoteValues?.destination?.CloseTime || quoteValues?.destination?.closetime || null)

      if(quoteValues?.accessorials?.origin?.length || quoteValues?.accessorials?.destination?.length || quoteValues?.accessorials?.other?.length){
        let accessorials = [...quoteValues?.accessorials?.origin, ...quoteValues?.accessorials?.destination, ...quoteValues?.accessorials?.other]

        if(quoteValues?.accessorials?.other?.length) {

          let acc = quoteValues?.accessorials?.other.filter(enabledAcc => enabledAcc.code === 'INS')
          if(acc.length) {   
            acc[0].insuranceAmount = quoteValues?.insuranceAmount
            formik.setFieldValue(`moneyAccessorialsInformation`, acc)
          }

          if(quoteValues?.insuranceAddOn) {
            formik.setFieldValue(`insuranceAddOn`, quoteValues?.insuranceAddOn)
          }
          if(quoteValues?.insuranceAmount) {
            formik.setFieldValue(`insuranceAmount`, quoteValues?.insuranceAmount)
          }
          if(quoteValues?.insuranceFreight) {
            formik.setFieldValue(`insuranceFreight`, quoteValues?.insuranceFreight)
          }
          if(quoteValues?.commodityInsurance) {
            formik.setFieldValue(`commodityInsurance`, quoteValues?.commodityInsurance)
          }
          if(quoteValues?.redkikQuoteId) {
            formik.setFieldValue(`redkikQuoteId`, quoteValues?.redkikQuoteId)
          }
          if(quoteValues?.coverTypeInsurance) {
             formik.setFieldValue(`coverTypeInsurance`,  quoteValues?.coverTypeInsurance)
          }
        }

        quoteValues?.newAccessorials?.forEach((newAccessorial) => {
          let accessorialsCodes = accessorials.map((a) => a?.code)
          if(!accessorialsCodes.includes(newAccessorial)){
            let newAccessorialWithAllInfo = user?.enabledAccessorials?.find(a => a?.code === newAccessorial)
            if(newAccessorialWithAllInfo?.code){
              accessorials.push(newAccessorialWithAllInfo)
            }
          }
        })

        setSelectedAcc(accessorials)
      }else if(quoteValues?.accessorials?.length){
        let accessorials = quoteValues?.accessorials

        quoteValues?.newAccessorials?.forEach((newAccessorial) => {
          let accessorialsCodes = accessorials.map((a) => a?.code)
          if(!accessorialsCodes.includes(newAccessorial)){
            let newAccessorialWithAllInfo = user?.enabledAccessorials?.find(a => a?.code === newAccessorial)
            if(newAccessorialWithAllInfo?.code){
              accessorials.push(newAccessorialWithAllInfo)
            }
          }
        })

        let acc = user.enabledAccessorials.filter(enabledAcc => enabledAcc.code === 'INS')               
      
        if(acc) {   
          formik.setFieldValue(`moneyAccessorialsInformation`, acc)
        }

        if(quoteValues?.insuranceAddOn) {
          formik.setFieldValue(`insuranceAddOn`, quoteValues?.insuranceAddOn)
        }
        if(quoteValues?.insuranceAmount) {
          formik.setFieldValue(`insuranceAmount`, quoteValues?.insuranceAmount)
        }
        if(quoteValues?.insuranceFreight) {
          formik.setFieldValue(`insuranceFreight`, quoteValues?.insuranceFreight)
        }
        if(quoteValues?.commodityInsurance) {
          formik.setFieldValue(`commodityInsurance`, quoteValues?.commodityInsurance)
        }
        if(quoteValues?.redkikQuoteId) {
          formik.setFieldValue(`redkikQuoteId`, quoteValues?.redkikQuoteId)
        }

        // setSelectedAcc(accessorials)
      }

      if(quoteValues.redkikQuoteId && quoteValues?.commodityInsurance && quoteValues?.insuranceAmount) {
        let accessorial = []
        let newAccessorialWithAllInfo = user?.enabledAccessorials?.find(a => a?.code === "INS")
        newAccessorialWithAllInfo['insuranceAmount'] = quoteValues?.insuranceAmount 
        if(newAccessorialWithAllInfo?.code){

              accessorial.push(newAccessorialWithAllInfo)
              formik.setFieldValue(`moneyAccessorialsInformation`, (newBookingValues?.moneyAccessorialsInformation || newAccessorialWithAllInfo))
            } 
        
            if(quoteValues?.insuranceAmount) {
              formik.setFieldValue(`insuranceAmount`, quoteValues?.insuranceAmount)
            }
            if(quoteValues?.insuranceFreight) {
              formik.setFieldValue(`insuranceFreight`, quoteValues?.insuranceFreight)
            }
            if(quoteValues?.insuranceAddOn) {
              formik.setFieldValue(`insuranceAddOn`, quoteValues?.insuranceAddOn)
            }
            if(quoteValues?.commodityInsurance) {
              formik.setFieldValue(`commodityInsurance`, quoteValues?.commodityInsurance)
            }
            if(quoteValues?.redkikQuoteId) {
              formik.setFieldValue(`redkikQuoteId`, quoteValues?.redkikQuoteId)
            }

        // setSelectedAcc(accessorial)        
      }

      const vendor = user.enabledVendors.find(vendor => vendor.id === quoteValues?.carrierInformation?.vendorId)

      if(quoteValues?.forQuotesGrid){
        formik.setFieldValue(`specialInstructions`, quoteValues?.notesBOLFromQuotesGrid?.replaceAll(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&"))

      }else{
        if(vendor?.showBOLInstructions){
          formik.setFieldValue(`specialInstructions`, `${vendor?.BOLInstructions?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&")} \n${user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&")}`)
        }else{
          formik.setFieldValue(`specialInstructions`, `${user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&")}`)
        }
      }

      formik.setFieldValue(`carrierInformation`, quoteValues?.carrierInformation)
      formik.setFieldValue(`quoteNumber`, quoteValues?.quoteNumber)

      // Fetch HAZ contact if quote has HAZ items and shipper has location id
      const hasHazmat = quoteValues?.freightInfo?.some(f => f.hazmat)
      const shipperLocationId = quoteValues?.originShippingLocationId || quoteValues?.origin?.shippingLocationId || quoteValues?.shipper?.shippingLocationId || quoteValues?.origin?.id || quoteValues?.shipper?.id

      if(hasHazmat && shipperLocationId){
        axios.get(GET_CONTACTS, {
          params: { shippingLocationId: shipperLocationId }
        }).then(results => {
          const contacts = results.data.data.results
          const hazContact = contacts?.find(contact => contact.type === "Emergency/Haz")
          if(hazContact){
            formik.setFieldValue('emergencyContact', `${hazContact.firstName} ${hazContact.lastName}`)
            formik.setFieldValue('emergencyPhone', hazContact.phone)
          }
        }).catch(() => {})
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteValues])

  // Watch for HAZ being marked in NewBooking and auto-fetch HAZ contact
  useEffect(() => {
    const hasHazmat = formik.values.freightInfo?.some(f => f.hazmat)
    const shipperId = formik.values.shipper?.id
    const hasEmergencyContact = formik.values.emergencyContact

    if(hasHazmat && shipperId && !hasEmergencyContact){
      axios.get(GET_CONTACTS, {
        params: { shippingLocationId: shipperId }
      }).then(results => {
        const contacts = results.data.data.results
        const hazContact = contacts?.find(contact => contact.type === "Emergency/Haz")
        if(hazContact){
          formik.setFieldValue('emergencyContact', `${hazContact.firstName} ${hazContact.lastName}`)
          formik.setFieldValue('emergencyPhone', hazContact.phone)
        }
      }).catch(() => {})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.freightInfo?.map(f => f.hazmat).join(','), formik.values.shipper?.id])

  useEffect(() => {
    const hasValidData = newBookingValues?.shipper?.name || newBookingValues?.consignee?.name
    if (initializedRef.current && hasValidData) return;
    if (hasValidData) initializedRef.current = true;

    if(quoteValues.length === 0){      
      // Preparar datos de shipper y consignee
      fillBookingData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newBookingValues])

  useEffect(() => {
    if(!openRatesModal){
      source.cancel('Operation canceled by the user.')
    }
  }, [openRatesModal])

  useEffect(() => {    
    const abortController = new AbortController()
    
    if(formik.values.carrierInformation.name && formik.values.pickupDate?.date instanceof Date && !isNaN(formik.values.pickupDate.date.getTime()) && formik.values.carrierInformation?.transitDays){
      axios.get(CALCULATE_DVLDATE, {
        params: {
          pickupDate: new Date(formik.values.pickupDate?.date) ? format(new Date(formik.values.pickupDate?.date) || null, 'yyyy-MM-dd') : '',
          transitDays: formik.values.carrierInformation?.transitDays || undefined,
          pickupTime: formik.values.pickupDate?.from || undefined,
          transitHours: getTransitHours(formik.values.carrierInformation) ?? undefined
        },
        signal: abortController.signal
      }).then((results) => {
        if(isMountedRef.current) {
          let callResults = results.data.data.results
          formik.setFieldValue('deliveryDate.date', new Date(callResults?.deliveryDate?.replace(/-/g, '/')))
          formik.setFieldValue('deliveryDateAllowed', new Date(callResults?.deliveryDate?.replace(/-/g, '/')))
          formik.setFieldValue('dateIsWeekendRemarks', [...callResults?.holidaysAffectingDeliveryDate, ...callResults?.pickupDateRemarks])

          if(callResults?.holidaysAffectingDeliveryDate?.length || callResults?.pickupDateRemarks?.length || callResults?.deliveryDateRemarks?.length){
            setOpenDateIsWeekendModal(true)
            setDateIsWeekendData({holidaysAffectingDeliveryDate: callResults?.holidaysAffectingDeliveryDate, pickupDateRemarks: callResults?.pickupDateRemarks, deliveryDateRemarks: callResults?.deliveryDateRemarks})
          }
        }
      }).catch((error) => {
        if(isMountedRef.current && error.name !== 'CanceledError') {
          console.error('Error calculating delivery date:', error)
        }
      })
    }else{
      if(parseInt(formik.values.carrierInformation?.transitDays) === 0){
        formik.setFieldValue(`deliveryDate.date`, formik.values.pickupDate.date)        
      }
      formik.setFieldValue('deliveryDateAllowed', null)
    }
    
    return () => {
      abortController.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.carrierInformation.name, formik.values.pickupDate?.date])

useEffect(() => {
    if(resetValues){
      setDispatchShip(false)
      const getCountryOptionsAllowed = () => {
        let defaultCountries = user?.defaultCountries
        let countriesArrayLocal = []
        defaultCountries?.forEach(country => {
            let allowedCountry = CountryOptions?.find(c => c.CodePrimus === country)
            if(allowedCountry?.CodePrimus) {
              countriesArrayLocal?.push(allowedCountry)
            }
        })
        return countriesArrayLocal.sort((a, b) => a.Name.localeCompare(b.Name))
      }
      let otherCountry = getCountryOptionsAllowed().find(c => c?.CodePrimus === 'USA') ? 'USA' : getCountryOptionsAllowed()[0].CodePrimus
      let initialNewBookingValuesLocal = {
        ...initialNewBookingValues,
        shipper: {
          ...initialNewBookingValues.shipper,
          country: initialNewBookingValues.shipper.country || otherCountry
        },
        consignee: {
          ...initialNewBookingValues.consignee,
          country: initialNewBookingValues.consignee.country || otherCountry
        }
      }
      // Reset form in one call to avoid multiple re-renders
      formik.resetForm({
        values: {
          ...initialValues,
          otherInfo: {
            ...initialValues.otherInfo,
            BKGRefNumber: '',
            BKGValue: ''
          },
          quoteNumber: '',
          selectedVendorCollect: '',
          stops: { stops: [] },
          specialInstructions: user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, "")
        },
        errors: {},
        touched: {}
      })
      dispatch({type: actionTypes.SetNewBookingValues, payload: initialNewBookingValuesLocal})
      dispatch({type: actionTypes.SetResetValues, payload: false})
      window.scrollTo(0, 0)
      setMode(modes.find(mode => mode.code === 'LTL'))
      setModeLocal(modes.find(mode => mode?.code === 'LTL')?.name)
      fillBookingData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetValues])

  useEffect(() => {    
    if(quoteValues?.mode) {
        getShipmentModeQuote(quoteValues)
    }
    else if(newBookingValues) {
        getShipmentMode(newBookingValues)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {    
    if(formik?.values?.carrierInformation?.vendorId) {
      getShipmentModeQuote(formik?.values)
    }
    
    // else if(formik?.values?.carrierInformation?.vendorId) {
    //   if(formik?.values.modeName) {
    //     getShipmentModeQuote(formik?.values)
    //   }
    //   else {
    //     getShipmentModeQuote(formik.values)
    //   }
      
    // }
}, [formik?.values?.carrierInformation])

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if(e?.target && (e.target as HTMLElement)?.id !== 'fieldAccessorials' && !(e.target as SVGElement).getAttribute("d")){
        setCloseAcc(true)
      }
    }
    
    window.addEventListener('click', handleClick)

    const vendorName = user.enabledVendors.find(vendor => vendor.id === (quoteValues?.carrierInformation?.vendorId || quoteValues?.carrierInformation?.id || newBookingValues?.vendorId))?.name
    if(vendorName && user?.allowVendorDisplay) {
      setVendorName(vendorName);
    }

    const vendorBOLInstructions = user.enabledVendors.find(vendor => vendor.id === quoteValues?.carrierInformation?.vendorId)?.BOLInstructions

    if(!newBookingValues.BOLNumber && !newBookingValues.specialInstructions && !vendorBOLInstructions){
      formik.setFieldValue('specialInstructions', user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, ""))
    }

    if(!newBookingValues?.freightInfoUOM.value && !quoteValues.freightInfoUOM?.value){
      formik.setFieldValue('freightInfoUOM.value', user?.defaultUOM)
      formik.setFieldValue('freightInfoTotals.symbol', user?.defaultUOM === 'US' ? 'lbs' : 'kgs')
    }
    
    return () => {
      window.removeEventListener('click', handleClick)
    }
  }, [])

  useEffect(() => {
    const abortController = new AbortController()
    
    if(newBookingValues.BOLId){
      axios.get(`${ADD_STOPS}/${newBookingValues.BOLId}/stops`, {
        signal: abortController.signal
      }).then(results => {
        if(isMountedRef.current) {
          formik.setFieldValue('stops.stops', results.data.data.results.map((stop) => {
            return({
              ...stop,
              address: stop.address1,
              address1: stop.address2,
              date: stop.pickupDeliveryDate,
              from: stop.pickupDeliveryTimeFrom ? moment(stop.pickupDeliveryTimeFrom, "HH:mm:ss").format('HH:mm') : '',
              to: stop.pickupDeliveryTimeTo ? moment(stop.pickupDeliveryTimeTo, "HH:mm:ss").format('HH:mm') : '',
              type: stop.pickupDelivery,
            })
          }))
        }
      }).catch((error) => {
        if(isMountedRef.current && error.name !== 'CanceledError') {
          console.error('Error loading stops:', error)
        }
      })
    }
    
    return () => {
      abortController.abort()
    }
  }, [newBookingValues.BOLId])

  useEffect(() => {
    let abortController: AbortController | null = null

    if(mode?.shipmentCategory === 'Drayage'){
      formik.setFieldValue('shipper.country', 'US')
      formik.setFieldValue('consignee.country', 'US')
      
      if(newBookingValues.freightInfo.length > 1){
        formik.setFieldValue('freightInfo', 
          newBookingValues.freightInfo.map((freight) => {
            const dimTypeAsContainer = typeof freight?.dimType === 'string' || typeof freight?.dimType === 'number'
              ? Number(freight.dimType)
              : null
            return ({
              ...freight,
              freightsnapId: freight?.freightSnapId ?? freight?.freightsnapId ?? null,
              container: freight?.container || dimTypeAsContainer || 20,
              class: 0,
              id: uuidv4(),
              UOM: {
                value: 'US',
                oldValue: ''
              },
              accessorials: [],
            })
          })
        )
      }else{
        formik.setFieldValue('freightInfo',
          formik.values.freightInfo.map((freight) => {
            const dimTypeAsContainer = typeof freight?.dimType === 'string' || typeof freight?.dimType === 'number'
              ? Number(freight.dimType)
              : null
            return({
                id: uuidv4(),
                container: freight?.container || dimTypeAsContainer || 20,
                qty: freight.qty,
                weightus: freight.weightus,
                class: 0,
                weight: freight.weight,
                UOM: {
                  value: 'US',
                  oldValue: ''
                },
                accessorials: [],
                UN: freight.UN,
                hazmat: freight.hazmat
            })
          })
        )
      }

      formik.setFieldValue('shipper', formik.values.shipper)
      formik.setFieldValue('consignee', formik.values.consignee)

      if(!ports.length){
        abortController = new AbortController()
        axios.get('/api/v1/tools/ports',
          {
            params: {portsList: customerInfo?.customerId && customerInfo.customerId == 166512180   ? 'customer' : 'all'},
            signal: abortController.signal
          }
        ).then(result => {
          if(isMountedRef.current) {
            let results = result.data.data.results
            const portsNormalized = results?.map(result => {
              return {
                country: result.country,
                name: result.name,
                postalCode: result.zipcode,
                stateCode: result.state,
                literal: `${result?.name}, ${result.state} ${result.zipcode}`,
                isPort: true,
                cityAlias: result.city,
                isZipcode: false,
                isSL: false
              }
            }).sort((a, b) => a.literal.localeCompare(b.literal))
            dispatch({type: actionTypes.SetDrayagePorts, payload: portsNormalized})
          }
        }).catch(error => {
          if(isMountedRef.current && error.name !== 'CanceledError') {
            checkErrorAPICall(error, dispatch, 'Ports')
          }
        })
      }
    }

    return () => {
      abortController?.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])

  useEffect(() => {
    if(user.lockedBOL) {
        setOpenErrorsInPageModal(true)
      }

    if(newBookingValues.BOLId) {
        formik.setFieldValue('billTo.emails', calculateEmail(newBookingValues?.thirdParty?.email))
    }
    else if(!newBookingValues.isBookingDuplicated){
        formik.setFieldValue('billTo.emails', [user?.email])
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetValues])

  /*
  useEffect(() => {
    if(Object.keys(formik.errors).length){
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openErrorsInPageModal])

  useEffect(() => {    
    if(formik.isSubmitting && Object.keys(formik.errors).length && formik.dirty){
      setOpenErrorsInPageModal(true)
    }
    if(user.lockedBOL) {
      setOpenErrorsInPageModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.errors])
  */

  let numberOfChips = window.innerWidth >= 1700 ? 4 : window.innerWidth <= 475 ? 1 : 3

  return (
    <>
    <form onSubmit={() => formik.handleSubmit()}>
      <PageTitle>{formik.values?.BOLNumber ? 'Shipment Details' : 'New Booking'}</PageTitle>      
      <div className="row" style={{marginRight: window.innerWidth > 991 && (fontSize === 9 ? 200 : fontSize === 11 ? 100 : 0)}}>
        <div className={`col-12 col-md-12 d-flex ${formik.values?.BOLNumber ? '' : 'align-items-start'} mb-5 ps-3 pe-0`}>
          <div className="row w-100" style={{alignContent: formik.values?.BOLNumber ? 'space-between' : ''}}>
            <div className='col-12 col-md-6 d-flex pe-12 order-md-1 order-2'>
            {(formik.values?.BOLNumber || isStreamline) &&
              <div className="col-12">
                <div className={`row ${!formik.values?.PRONmbr ? 'mb-5 mb-md-0' : ''}`}>
                  <div className={`col-12 d-flex align-items-center`}>
                    <h2 className='mb-0'>{`BOL #${formik?.values?.BOLPrefix || ''}${formik?.values?.BOLNumber || ''}`}</h2>
                    {
                      user?.allowBOLModify &&
                      <IconButton onClick={() => setOpenChangeBOLModal(true)} disabled={newBookingValues.dispatched}>
                        <EditIcon style={{width: 21, height: 21}}/>
                      </IconButton>
                    }
                  </div>
                  <div className="col-12 d-flex align-items-center">
                    <h5 className='mb-0' style={{fontWeight: 400}}>PRO #{formik.values?.PRONmbr}</h5>
                    {
                      user?.allowPROModify &&
                      <IconButton onClick={() => setOpenAttachPROModal(true)} disabled={newBookingValues.dispatched}>
                        <EditIcon style={{width: 15, height: 15}}/>
                      </IconButton>
                    }
                  </div>
                </div>
              </div>
            }
              </div>          
            <div className='col-12 col-md-6 d-flex mb-2 order-md-2 order-3 flex-wrap align-content-end'>
                <h5 className='mb-0 me-2' style={{fontSize: 14}}>Bill To</h5> <h5 className='mb-0' style={{fontSize: 14, fontWeight: 400}}>{user?.billToInformation.name}</h5>
            </div>
            
            <div className={`col-12 col-md-6 d-flex align-items-start order-md-3 order-1 align-content-start flex-wrap`}>
              <div className='col-3 col-md-2 mb-5'>
                <label className='col-form-label lh-1'>Mode</label>
              </div>
              <div className='col-9 col-md-5 p-0 ps-md-1'>
                <SelectStyled
                  value={modeLocal || ''}
                  disabled={newBookingValues.dispatched}
                  onChange={(e) => {
                    setModeLocal(e.target.value)
                    setMode(modes.find(m => m?.name === e.target.value))
                  }}
                  className={`w-100 ${classes.select}`}
                  displayEmpty={true}
                  inputProps={{
                    IconComponent: KeyboardArrowDownIcon,
                    MenuProps: menuProps,
                    style: stylesMUIInput(fontSize),
                  }}
                  style={{
                    color: '#5E6278',
                  }}
                  fontSize={fontSize}
                >
                  {
                    modes?.map((mode, index) => {
                      return <MenuItem key={index} value={mode.name}>{mode.name}</MenuItem>
                    })
                  }
                </SelectStyled>
              </div>
            </div>

            {/* <div className="col-3 d-flex mb-5">
              <h5 className='mb-0 me-2' style={{fontSize: 14}}>Bill To</h5> <h5 className='mb-0' style={{fontSize: 14, fontWeight: 400}}>{user?.billToInformation.name}</h5>
            </div> */}


            <div className='col-12 col-md-6 d-md-flex align-items-start order-md-4 order-4 flex-column' style={{backgroundColor: 'rgb(228,230,239)', borderRadius: '0.475rem', padding: '0.75rem'}}>
              
              <div className='col-12 col-md-12 col-xs-12 d-flex'>
                <div className="col-2 col-md-2 me-2">
                  <label className='col-form-label lh-1'>Reference#</label>
                </div>
                <div className="col-10 col-md-10 mb-2">
                  <InputStyled
                    type="text"
                    autoComplete='new-password'
                    {...formik.getFieldProps('billTo.referenceNumber')}
                    maxLength="120"
                    fontSize={fontSize}
                    className={`form-control ${newBookingValues.dispatched && 'disabled'}`}
                    disabled={newBookingValues.dispatched}
                  />
                </div>
              </div>
              <div className='col-12 col-md-12 col-xs-12 d-flex'>
                <div className="col-2 col-md-2 me-2">
                  <label className='col-form-label'>Email</label>
                </div>
                <div className="col-10 mb-5 mb-md-0">
                  <ReactMultiEmailStyled
                    error={(formik.values.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length ? true : false}
                    disabled={newBookingValues.dispatched}
                    enable={(emailCnt) => !newBookingValues.dispatched}
                    propsEmails={formik.values.billTo.emails || []}
                    onChange={(_emails: string[]) => {
                        formik.setFieldValue('billTo.emails', _emails)
                    }}
                    getLabel={(email, index, removeEmail) => (
                      index === numberOfChips ? '...'  : index > numberOfChips ? null :
                      <ChipStyled
                        chipforemail="true"
                        disabled={newBookingValues.dispatched}
                        key={index}
                        tabIndex={-1}
                        onDelete={() => {
                            if(!newBookingValues.dispatched){
                                removeEmail(index)
                            }
                        }}
                        label={email?.includes('notanemail') ? email?.replace('notanemail@gmail.com', '') : email}
                        className='me-1 mb-1'
                        style={{height: fontSize < 13 && 25}}
                      />
                    )}
                    onFocus={() => newBookingValues.dispatched && (document?.activeElement as any)?.blur()}
                  />
                </div>
              </div>
            </div>
            <div className={`col-6 order-last`}>
                
            </div>
            <div className={`col-6 order-last mt-4 mb-4`}>
              {user?.enableCollect && (
                <BillToCollect formik={formik} openCollectInformationModal={openCollectInformationModal} setOpenCollectInformationModal={setOpenCollectInformationModal} setFormikValues={formik.setFieldValue} isCollect={isCollect} setIsCollect={setIsCollect}/>
              )}
            </div>
          </div>
        </div>  
        {/* <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end mb-5">
          <div className="row w-xl-75">
            <div className="col-12 d-flex mb-5">
              <h5 className='mb-0 me-2' style={{fontSize: 14}}>Bill To</h5> <h5 className='mb-0' style={{fontSize: 14, fontWeight: 400}}>{user?.billToInformation.name}</h5>
            </div>
            <div className="col-3 mb-5">
              <label className='col-form-label'>Reference#</label>
            </div>
            <div className="col-9 mb-5">
              <InputStyled
                type="text"
                autoComplete='new-password'
                {...formik.getFieldProps('billTo.referenceNumber')}
                maxLength="120"
                fontSize={fontSize}
                className={`form-control ${newBookingValues.dispatched && 'disabled'}`}
                disabled={newBookingValues.dispatched}
              />
            </div>
            <div className="col-3 mb-5 mb-md-0">
              <label className='col-form-label'>Email</label>
            </div>
            <div className="col-9 mb-5 mb-md-0">
              <ReactMultiEmailStyled
                disabled={newBookingValues.dispatched}
                enable={(emailCnt) => !newBookingValues.dispatched}
                propsEmails={formik.values.billTo.emails || []}
                onChange={(_emails: string[]) => {
                    formik.setFieldValue('billTo.emails', _emails)
                }}
                getLabel={(email, index, removeEmail) => (
                  index === numberOfChips ? '...'  : index > numberOfChips ? null :
                  <ChipStyled
                    chipforemail="true"
                    disabled={newBookingValues.dispatched}
                    key={index}
                    tabIndex={-1}
                    onDelete={() => {
                        if(!newBookingValues.dispatched){
                            removeEmail(index)
                        }
                    }}
                    label={email}
                    className='me-1 mb-1'
                    style={{height: fontSize < 13 && 25}}
                  />
                )}
                onFocus={() => newBookingValues.dispatched && (document?.activeElement as any)?.blur()}
              />
            </div>
          </div>
        </div> */}
        <div className="col-12 col-lg-6 mb-10 mb-lg-0">
          <label className='col-form-label py-0 me-1'>Shipper</label>
          <Tooltip title={!newBookingValues.dispatched && (formik.values.shipper.zipcode || formik.values.consignee.zipcode) ? "View in Google Maps" : ''}>
            <IconButton
              size="small"
              onClick={() => openMaps(newBookingValues, formik.values)}
              disabled={!newBookingValues.dispatched && (formik.values.shipper.zipcode || formik.values.consignee.zipcode) ? false : true}
            >
              <LocationOnIcon/>
            </IconButton>
          </Tooltip>
          <hr style={{color: '#a7adce'}} className='mb-4'/>
          <OriginAndDestination
            formFor='shipper'
            formik={formik}
            user={user}
            disabled={newBookingValues.dispatched}
            setOpenClearRateToEditModal={setOpenClearRateToEditModal}
            newValuesWhenRateCleared={newValuesWhenRateCleared}
            setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
            formikDispatch={formik}
            dispatchShip={dispatchShip}
            mode={mode}
            openClearRateToEditModal={openClearRateToEditModal}
          />
        </div>
        <div className="col-12 col-lg-6">
          <label className='col-form-label py-0 me-1'>Consignee</label>
          <Tooltip title={!newBookingValues.dispatched && (formik.values.shipper.zipcode || formik.values.consignee.zipcode) ? "View in Google Maps" : ''}>
            <IconButton
              size="small"
              onClick={() => openMaps(newBookingValues, formik.values)}
              disabled={!newBookingValues.dispatched && (formik.values.shipper.zipcode || formik.values.consignee.zipcode) ? false : true}
            >
              <LocationOnIcon/>
            </IconButton>
          </Tooltip>
          <hr style={{color: '#a7adce'}} className='mb-4'/>
          <OriginAndDestination
            formFor='consignee'
            formik={formik}
            user={user}
            disabled={newBookingValues.dispatched}
            setOpenClearRateToEditModal={setOpenClearRateToEditModal}
            newValuesWhenRateCleared={newValuesWhenRateCleared}
            setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
            formikDispatch={formik}
            dispatchShip={dispatchShip}
            mode={mode}
            openClearRateToEditModal={openClearRateToEditModal}
          />
        </div>
        <div className={`col-12 ${marginSize(fontSize, 'mt-10 mb-3', 'mt-4 mb-1')}`}>
          <label className='col-form-label'>Freight Info</label>
        </div>        
        <div className={`col-12 ${mode?.shipmentCategory === 'Drayage' ? '' : 'd-flex align-items-center'} mb-5 g-0`}
        style={{ backgroundColor: 'rgb(228, 230, 239)', borderRadius: '0.475rem',border: '1px solid #E4E6EF', padding: '10px 20px', marginBottom: '10px'}}>
          {mode?.shipmentCategory === 'Drayage' ? formik?.values?.freightInfo?.map((freight, index) => (
            <Fragment key={index}>
              <div className={`col-12 col-xl-11 ${marginSize(fontSize, 'mb-6', 'mb-1')}`} >              
              <Container
                index={index}
                freight={freight}
                handleChange={formik.handleChange}
                setData={formik.setFieldValue}
                freightInfo={formik.values.freightInfo}
                errors={formik.errors.freightInfo && (formik.errors.freightInfo[index])}
                touched={formik?.touched?.freightInfo && formik?.touched?.freightInfo[index]}
                setFieldTouched={formik.setFieldTouched}
                forNewBooking={true}
                setSelectedUn={setSelectedUn}
                selectedUn={selectedUn}
              />
              </div>
            </Fragment>
          ))
          : null}
          {
            mode?.shipmentCategory !== 'Drayage' ? 
            <div className="row g-0">                           
              {formik?.values?.freightInfo?.map((freight, index) => (
                <Fragment key={index}>
                  <FreightInformation
                    setDataFormik={formik.setFieldValue}
                    freightInfo={formik.values.freightInfo}
                    index={index}
                    freight={freight}
                    freightInfoUOM={formik.values.freightInfoUOM}
                    handleChange={formik.handleChange}
                    formik={formik}
                    errors={(formik.errors.freightInfo && (formik.errors.freightInfo[index] as freightErrors)) || (formik.errors.freightInfo && (formik.errors.freightInfo[index] as freightErrors))}
                    touched={(formik?.touched?.freightInfo && formik?.touched?.freightInfo[index]) || (formik?.touched?.freightInfo && formik?.touched?.freightInfo[index])}
                    disabled={newBookingValues.dispatched}
                    freightForNewBooking={true}
                    formikValues={formik.values}
                    setOpenClearRateToEditModal={setOpenClearRateToEditModal}
                    formikDispatch={formik}
                    dispatchShip={dispatchShip}
                    mode={mode}
                    setOpenHazContactModal={setOpenHazContactModal}
                    setSelectedUn={setSelectedUn}
                    selectedUn={selectedUn}
                    setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
                  />
                </Fragment>
              ))}
            </div>
            : null
          }
        </div>
        <div className="row g-0">          
          <FreightTotals
            freightInfoTotals={formik?.values?.freightInfoTotals}
            freightInfo={formik?.values?.freightInfo}
            freightInfoUOM={formik?.values?.freightInfoUOM}
            setDataFormik={formik?.setFieldValue}
            forDrayage={mode?.shipmentCategory === 'Drayage'}
          />
          <SelectUOM
            freightInfoUOM={formik.values.freightInfoUOM}
            setDataFormik={formik.setFieldValue}
            freightInfo={formik.values.freightInfo}
            freightInfoTotals={formik.values.freightInfoTotals}
            disabled={newBookingValues.dispatched}
            readOnly={user?.disableMetricDataEntry}
            hazContact={true}
            setOpenHazContactModal={setOpenHazContactModal}
            formik={formik}
            setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
            setOpenClearRateToEditModal={setOpenClearRateToEditModal}
          />
        </div>
        <div className={`col-12 ${marginSize(fontSize, 'mt-7 mb-3', 'mt-4 mb-1')}`}>
          <label className='col-form-label'>Accessorials</label>
        </div>
        <div className="col-xl-8 col-sm-12" style={{position: 'relative'}}>
          <Accessorials
            closeAcc={closeAcc}
            setCloseAcc={setCloseAcc}
            selectedAcc={selectedAcc}
            setSelectedAcc={setSelectedAcc}
            accessorialsList={user?.enabledAccessorials?.filter(accessorial => accessorial.code !== 'HAZ')}
            formikValues={formik.values}
            setTouchedDate={setTouchedDate}
            formik={formik}
            setOpenClearRateToEditModal={setOpenClearRateToEditModal}
            setFormikValues={formik.setFieldValue}
            forNewBooking={true}
            actionClicked={actionClicked}
            setOpenErrorsInPageModal={setOpenErrorsInPageModal}
            setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
            setIsAccesorialsOpenend={setIsAccesorialsOpenend}
          />
        </div>
        <div className='ps-3 pe-3'>
          <hr style={{color: '#a7adce'}} className='mt-6 mb-6'/>
        </div>
        {user.allowQuoting && (
        <div className='col-12 d-flex align-items-center justify-content-end' style={{ marginTop: isAccesorialsOpenend ? '160px' : '10px'}}>
          <button
            className={`btn btn-secondary me-4 ${newBookingValues.dispatched ? 'disabled' : formik.values?.carrierInformation?.name ? '' : 'disabled'}`}
            onClick={(e) => {
              e.preventDefault()
              setActionClicked(!actionClicked)
              setOpenConfirmClearRateModal(true)
            }}
          >
            Clear Rate
          </button>
          <button
            className={`btn btn-primary ${newBookingValues.dispatched ? 'disabled' : ''}`}
            disabled={newBookingValues.dispatched || isCollect}
            onClick={() => {
              submitButtonLet = 'quote'
              setSubmitButton('quote')
              setActionClicked(!actionClicked)
              setDispatchShip(false)
              setTouchedDate({
                ...touchedDate,
                pickup: true
              })
              formik.submitForm()

              if(Object.keys(formik.errors).length){
                setOpenErrorsInPageModal(true)
                window.scrollTo(0, 0)
              }
            }}
            type="button"
          >
            Get Rates
          </button>
        </div>
        )}

        {isCollect && (
          <>
            <hr style={{color: '#a7adce'}} className='mt-6 mb-6'/>
            <div className={`col-12`}>
              <label className='col-form-label'>Rate Quote Details</label>
            </div>
            <div className='col-12 d-flex align-items-center justify-content-start'>
              <div className="me-2 mb-2 mb-xl-0 mt-4" style={{display: 'flex', alignItems: 'center'}}>
                  <label className='col-form-label' style={{marginRight: '10px'}}>Carrier</label>
                  <Autocomplete
                    value={formik.values?.selectedVendorCollect || null}
                    onChange={(e, value) => {
                      formik.setFieldValue('selectedVendorCollect', value)
                      
                      if(value?.id) {
                        setCollectData(value)
                      }
                      else {
                        formik.setFieldValue('collectVendorId', '')
                        if(!value) {
                          formik.setFieldValue('selectedVendorCollect', value)
                          formik.setFieldValue('collectVendorName', '')
                        formik.setFieldValue(`carrierInformation`, {})
                        formik.setFieldValue('specialInstructions', user.bookingDisclaimer?.replace(/<\/?[^>]+(>|$)/g, ""))
                        }  
                      }

                    }}
                    
                    options={vendorsCollect || []}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option?.name || ''}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.name}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    sx={{ width: 200, height: 30 }}
                    popupIcon={<KeyboardArrowDownIcon />}
                    autoHighlight={true}
                    className='dropdownContainer'
                    forcePopupIcon={false}
                    selectOnFocus
                    handleHomeEndKeys
                    clearOnBlur={false}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        autoComplete='new-password'
                        error={isCollect && formik?.errors?.selectedVendorCollect}
                        helperText={formik?.errors?.selectedVendorCollect}
                        variant="outlined"
                        onBlur={(e) => {
                          // formik.setFieldValue('selectedVendorCollect', value)
                          if(!formik.values.collectVendorId) {
                              formik.setFieldValue('collectVendorName', e.target.value)
                              formik.setFieldValue('selectedVendorCollect', e.target.value)
                            }                   
                        }}
                        label=" "
                        // style={{top: '-16px', position: 'relative'}}
                        name={`selectedVendorCollect`}
                        className="textfieldCollect"
                        InputProps={{
                          ...params.InputProps,
                          style: {fontSize: 14, fontFamily: 'Poppins', fontWeight: 500, backgroundColor:'white',
                            height: '30px',
                            lineHeight: '1.5',
                            color: '#5E6278',
                            border: '1px solid #E4E6EF',
                            appearance: 'none',
                            borderRadius: '0.475rem',
                            padding: 0,
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& .MuiAutocomplete-input': {
                              padding: '0 8px', // Adjust as needed
                            },
                          },
                        }}
                        InputLabelProps={{shrink: false}}                        
                      />
                    )}
                  />
              </div>
              <div className="me-2 mb-2 mb-xl-0 mt-4" style={{display: 'flex', alignItems: 'center'}}>
                  <label className='col-form-label' style={{marginLeft: '10px', marginRight: '10px', width: '80px' }}>Quote #</label>
                  <InputStyled
                      type="text"
                      // autoComplete='new-password'
                      {...formik.getFieldProps('collectQuoteNumber')}
                      maxLength="24"
                      fontSize={fontSize}
                      className={`form-control ${newBookingValues.dispatched && 'disabled'}`}
                                            // disabled={newBookingValues.dispatched}
                    />
              </div>
              <div className="me-2 mb-2 mb-xl-0 mt-4" style={{display: 'flex', alignItems: 'center', visibility: 'hidden' }}>
                  <label className='col-form-label' style={{marginLeft: '10px', marginRight: '10px', width: '150px' }}>Quote Amount</label>
                  <InputStyled
                      type="text"
                      // autoComplete='new-password'
                      {...formik.getFieldProps('collectQuoteAmount')}
                      maxLength="24"
                      fontSize={fontSize}
                      className={`form-control ${newBookingValues.dispatched && 'disabled'}`}
                    />
              </div>
              
            </div>
            <hr style={{color: '#a7adce'}} className='mt-6 mb-6'/>
          </>
        )}
          
        {!isCollect && formik?.values?.carrierInformation?.name &&
          <div className='mt-3'>
            <CarrierInformation
              vendorName={vendorName}
              userAllowQuoting={user?.allowQuoting}
              values={formik?.values}
              setOpenQuoteBreakdownModal={setOpenQuoteBreakdownModal}
            />
          </div>
        }
        <div className={`col-12 col-lg-7 ${marginSize(fontSize, 'mt-12', 'mt-8')}`}>
          <label className='col-form-label mb-5'>Pickup and Delivery</label>
          <PickupAndDelivery
            date='Pickup'
            setDataFormik={formik.setFieldValue}
            handleChange={formik.handleChange}
            error={formik.errors?.pickupDate}
            values={formik.values.pickupDate}
            formik={formik}
            touched={touchedDate}
            setTouched={setTouchedDate}
            formikDispatch={formik}
            dispatchShip={dispatchShip}
            hasAppointmentAccessorial={selectedAcc?.some(acc => acc.nameShort?.toLowerCase() === 'appointment' && acc.category === 'Origin')}
          />
          <PickupAndDelivery
            date='Delivery'
            setDataFormik={formik.setFieldValue}
            handleChange={formik.handleChange}
            error={formik.errors?.deliveryDate}
            values={formik.values.deliveryDate}
            formik={formik}
            touched={touchedDate}
            setTouched={setTouchedDate}
            formikDispatch={formik}
            dispatchShip={dispatchShip}
            hasAppointmentAccessorial={selectedAcc?.some(acc => acc.nameShort?.toLowerCase() === 'appointment' && acc.category === 'Destination')}
          />
          <div className="mt-2" style={{color: '#a1a5b7', fontSize: fontSize !== 13 ? `${fontSize - 1}px` : '12px', lineHeight: '1.4'}} dangerouslySetInnerHTML={{ __html: user?.appletBookingNotes.replace(/\n+/g,"<br />") }} />
        </div>
        <div className={`col-12 col-lg-5 ${marginSize(fontSize, 'mt-12', 'mt-8')}`}>
          <Tabs
            formik={formik}
            mode={mode}
          />
        </div>
        <div className="row pe-0 mt-6 align-items-center justify-content-end">
          <div className="d-flex align-items-center justify-content-end pe-0" style={{flexWrap: 'wrap'}}>
            {user?.allowBooking && !formik?.values?.dispatched && !formik.values?.BOLId && !isStreamline &&
              <button
                className={`btn btn-primary ${formik.values?.BOLId && 'me-4'} d-flex align-items-center justify-content-center`}
                onClick={(e) => {
                  e.preventDefault()
                  setActionClicked(!actionClicked)
                  setDispatchShip(false)
                  
                  if([...formik?.values?.accessorials?.origin, ...formik?.values?.accessorials?.destination, ...formik?.values?.accessorials?.other].filter(a => a.code === 'INS')?.length
                  && (!formik?.values?.moneyAccessorialsInformation?.filter(a => a.code === 'INS' && a.insuranceAmount).length && !formik?.values?.insuranceAmount)) {
                    setOpenInsuranceRequiredModal(true)
                  }
                  else if(isCollect && formik?.values?.selectedVendorCollect && !formik.values.collectVendorId) {
                    setOpenCollectVendorSetup(true)
                  }
                  else{
                    createShipment()
                  }
                }}
                disabled={user?.lockedBOL || loadingCreateShipment}
              >
                  Create Shipment {loadingCreateShipment && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
              </button>
            }
            {isStreamline && user?.allowBooking && !formik?.values?.dispatched &&
              <StreamlineSaveDropdown
                disabled={user?.lockedBOL}
                loading={loadingCreateShipment || loadingUpdateShipment || loadingDispatchShipment}
                onSaveAndDispatch={handleStreamlineSaveAndDispatch}
                onSaveBooking={handleStreamlineSaveBooking}
                onSaveAndClose={handleStreamlineSaveAndClose}
                className={`me-0 me-sm-4 mb-2 mb-sm-0 ${window.innerWidth <= 576 ? 'w-100' : ''}`}
              />
            }
            {!formik?.values?.dispatched && formik.values?.BOLId && !isStreamline &&
              <button
                className={`btn btn-primary ${formik.values?.BOLId && 'me-0 me-sm-4'} d-flex align-items-center justify-content-center mb-2 mb-sm-0 ${window.innerWidth <= 576 && 'w-100'}`}
                disabled={user?.lockedBOL || loadingDispatchShipment}
                type="submit"
                onClick={(e) => {
                  e.preventDefault()
                  triggerReadyToDispatch()
                }}
              >
                Ready to Dispatch {loadingDispatchShipment && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
              </button>
            }
            {user?.allowBooking && !formik?.values?.dispatched && formik.values?.BOLId && !isStreamline &&
              <button
                disabled={user?.lockedBOL || loadingUpdateShipment || loadingDispatchShipment}
                className={`btn btn-primary ${formik.values?.BOLId && 'me-0 me-sm-4'} d-flex align-items-center justify-content-center mb-2 mb-sm-0 ${window.innerWidth <= 576 && 'w-100'}`}
                onClick={(e) => {
                  e.preventDefault()
                  setActionClicked(!actionClicked)
                  setDispatchShip(false)
                  updateShipment()
                }}
              >
                  Update Shipment {loadingUpdateShipment && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
              </button>
            }
            <br/>
            {
              isStreamline && !formik.values?.BOLId &&
              <>
                <button
                  className="btn btn-primary me-4 d-flex align-items-center"
                  onClick={(e) => {
                    e.preventDefault()
                    setOpenUploadDocumentsTemporaryModal(true)
                  }}
                >
                  Documents {loadingDocuments && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                </button>
                  <UploadDocument
                      open={openUploadDocumentsTemporaryModal}
                      setOpen={setOpenUploadDocumentsTemporaryModal}
                      preloadMode={!formik.values.BOLId}
                      onPreloadFiles={(files) => setPendingDocuments(files)}
                      pendingFiles={pendingDocuments}
                  />
              </>
            }
            {
              formik.values?.BOLId &&
              <>
                <button
                  className="btn btn-primary me-4 d-flex align-items-center"
                  onClick={(e) => {
                    e.preventDefault()
                    setActionClicked(!actionClicked)
                    getDocuments()
                  }}
                >
                  Documents {loadingDocuments && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
                </button>
              </>
            }
            {
              (user?.allowTrack && formik.values?.BOLId) ?
              <button
                  className="btn btn-primary d-flex align-items-center me-0 me-sm-4"
                  onClick={(e) => {
                    e.preventDefault()
                    setActionClicked(!actionClicked)
                    trackingAction()
                  }}
              >
                  Tracking {loadingTracking && <CircularProgress style={{height: 16, width: 16, color: 'white'}} className='ms-2'/>}
              </button>
              : null
            }
            {
              formik.values?.BOLNumber ?
              <button
                className="btn btn-secondary d-flex align-items-center mt-2 mt-sm-0 ms-4 ms-sm-0"
                onClick={(e) => {
                  e.preventDefault()
                  setActionClicked(!actionClicked)
                  setOpenSaveChangesModal(true)
                }}
              >
                Close
              </button>
              : null
            }
          </div>
        </div>
      </div>
      <QuoteBreakdownModal
        open={openQuoteBreakdownModal}
        setOpen={setOpenQuoteBreakdownModal}
        data={formik?.values?.carrierInformation}
      />
      <ConfirmClearRateModal
        open={openConfirmClearRateModal}
        setOpen={setOpenConfirmClearRateModal}
        setFormikValues={formik.setFieldValue}
      />
      <RatesModal
        open={openRatesModal}
        setOpen={setOpenRatesModal}
        linearProgress={linearProgress}
        rates={rates}
        setFormikValues={formik.setFieldValue}
        ratesStopped={ratesStopped}
        setRatesStopped={setRatesStopped}
        source={source}
        setVendorName={setVendorName}
        vendorsFiltered={enabledVendors}
        vendorsProcessed={vendorsProcessed}
        formikValues={formik.values}
        setOpenAddRateRemarksModal={setOpenAddRateRemarksModal}
      />
      <TrackingModal
        open={openTrackingModal}
        setOpen={setOpenTrackingModal}
        historyTrackings={historyTrackings}
        setHistoryTrackings={setHistoryTrackings}
        rowData={formik.values}
      />
      <DocumentsModal
        open={openDocumentsModal}
        setOpen={setOpenDocumentsModal}
        documents={documents}
        selectedRow={{BOLNumber: `${formik.values?.BOLPrefix}${formik.values.BOLNumber}`, BOLId: formik.values.BOLId}}
        setDocuments={setDocuments}
      />
      <ShipmentCreatedOrUpdatedModal
        open={openShipmentCreatedModal}
        setOpen={setOpenShipmentCreatedModal}
        values={formik.values}
        setFormikValues={formik.setFieldValue}
        createOrUpdate={createOrUpdate}
      />
      <ClearRateToEditModal
        open={openClearRateToEditModal}
        setOpen={setOpenClearRateToEditModal}
        setFormikValues={formik.setFieldValue}
        newValuesWhenRateCleared={newValuesWhenRateCleared}
        setNewValuesWhenRateCleared={setNewValuesWhenRateCleared}
        formik={formik}
        //setOpenRemarksMessageModal={setOpenRemarksMessageModal}
      />
      <SaveChangesModal
        open={openSaveChangesModal}
        setOpen={setOpenSaveChangesModal}
        updateShipment={updateShipment}
      />
      <HazContactModal
        open={openHazContactModal}
        setOpen={setOpenHazContactModal}
        setFormikValues={formik.setFieldValue}
        formikValues={formik.values}
      />
      <PickupDatePastModal
        open={openPickupDatePastModal}
        setOpen={setOpenPickupDatePastModal}
        dispatchAction={dispatchAction}
      />
      <ChangeBOLNumberModal
        open={openChangeBOLModal}
        setOpen={setOpenChangeBOLModal}
        BOLId={formik.values.BOLId}
        BOLNumberProps={formik.values.BOLNumber}
        BOLPrefix={formik.values?.BOLPrefix}
        setFormikValues={formik.setFieldValue}
      />
      <AttachPRONumberModal
        open={openAttachPROModal}
        setOpen={setOpenAttachPROModal}
        BOLId={formik.values.BOLId}
        setFormikValues={formik.setFieldValue}
        formikValues={formik.values}
        PRONumberProps={formik.values.PRONmbr}
      />
      <ErrorsInPageModal
        open={openErrorsInPageModal} 
        setOpen={setOpenErrorsInPageModal}
        invalidData={(formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length || (formik.values?.shipper?.emails ? formik.values?.shipper?.emails?.filter(email => email?.includes('notanemail'))?.length : false) || (formik.values?.consignee?.emails ? formik.values?.consignee?.emails?.filter(email => email?.includes('notanemail'))?.length : false) ? true : false}
        lockedBOL={user.lockedBOL}
      />
      <VendorCollectModal
        open={openCollectVendorSetup} 
        setOpen={setOpenCollectVendorSetup}
        formik={formik}
        // invalidData={(formik.values?.billTo?.emails || [])?.filter(email => email?.includes('notanemail'))?.length || (formik.values?.shipper?.emails ? formik.values?.shipper?.emails?.filter(email => email?.includes('notanemail'))?.length : false) || (formik.values?.consignee?.emails ? formik.values?.consignee?.emails?.filter(email => email?.includes('notanemail'))?.length : false) ? true : false}
        // lockedBOL={user.lockedBOL}
      />
       <ConfirmTimedOutVendorsModal
        open={openConfirmTimedOutModal}
        setOpen={setOpenConfirmTimedOutModal}
        vendorsTimedOut={vendorsTimedOut}
        keepWaitingVendors={() => {
          source = cancelToken.source()
          keepWaitingVendors()
        }}
        formikValues={formik.values}
      />
      <NoVendorsSetUpModal
        open={openNoVendorsSetUpModal}
        setOpen={setOpenNoVendorsSetUpModal}
      />
      <InsuranceRequiredModal
        open={openInsuranceRequiredModal}
        setOpen={setOpenInsuranceRequiredModal}
      />
      <CarrierRequiredModal
        open={openCarrierRequiredModal}
        setOpen={setOpenCarrierRequiredModal}
      />
      <NMFCRequiredModal
        open={openNMFCRequiredModal}
        setOpen={setOpenNMFCRequiredModal}
      />
      <SmallPackageOptionsModal
        open={openSmallPackageOptionsModal}
        setOpen={setOpenSmallPackageOptionsModal}
        smallPackageOptions={smallPackageOptions}
        dispatchAction={(params) => dispatchAction(params, setLoadingDispatchShipment)}
        loadingDispatchShipment={loadingDispatchShipment}
      />
      <DateIsWeekendModal
        setOpen={setOpenDateIsWeekendModal}
        open={openDateIsWeekendModal}
        formikValues={formik.values}
        dateIsWeekendData={dateIsWeekendData}
      />
      <AddRateRemarksModal
        open={openAddRateRemarksModal}
        setOpen={setOpenAddRateRemarksModal}
        formikValues={formik.values}
        setFormikValues={formik.setFieldValue}
      />
    </form>
    </>
  )
}